// Mailchimp footer newsletter form
window.fourFooterMailchimpSubmit = function (event, form) {
    if (event && event.defaultPrevented) return false;
    if (event) event.preventDefault();
    if (!form) return false;

    const email = form.querySelector('input[name="EMAIL"]');
    const error = form.querySelector("[data-mailchimp-message]");
    const submitButton = form.querySelector('button[type="submit"]');

    function setMessage(text, isError) {
        if (!error) return;
        error.textContent = text || "";
        error.hidden = !text;
        error.classList.toggle("is-error", Boolean(isError));
    }

    function stripHtml(value) {
        const div = document.createElement("div");
        div.innerHTML = value || "";
        return div.textContent || div.innerText || "";
    }

    setMessage("", false);

    if (!email || !email.value.trim()) {
        setMessage("Please enter your email address.", true);
        if (email) email.focus();
        return false;
    }

    if (!email.checkValidity()) {
        setMessage("Please enter a valid email address.", true);
        email.focus();
        return false;
    }

    const jsonUrl = form.dataset.mailchimpJsonUrl;
    if (!jsonUrl) {
        setMessage("Unable to subscribe. Please try again.", true);
        return false;
    }

    const callbackName = "fourMailchimpCallback" + Date.now();
    const params = new URLSearchParams(new FormData(form));
    params.append("c", callbackName);

    setMessage("Submitting...", false);
    if (submitButton) submitButton.disabled = true;

    const script = document.createElement("script");
    window[callbackName] = function (response) {
        const isSuccess = response && response.result === "success";
        const responseMessage = stripHtml(response && response.msg);

        setMessage(
            responseMessage || (isSuccess ? "Thank you for subscribing." : "Unable to subscribe. Please try again."),
            !isSuccess
        );

        if (isSuccess) form.reset();
        if (submitButton) submitButton.disabled = false;
        delete window[callbackName];
        script.remove();
    };
    script.onerror = function () {
        setMessage("Unable to subscribe. Please try again.", true);
        if (submitButton) submitButton.disabled = false;
        delete window[callbackName];
        script.remove();
    };
    script.src = jsonUrl + "&" + params.toString();
    document.body.appendChild(script);

    return false;
};

document.addEventListener("submit", function (event) {
    const form = event.target.closest("[data-mailchimp-form]");
    if (!form) return;
    window.fourFooterMailchimpSubmit(event, form);
}, true);

// Custlo invoice PDF capture fix ========================
document.addEventListener("DOMContentLoaded", function () {
    const invoiceSelector = "#classic-invoice";
    const invoiceDownloadSelector = ".custlo-t1-download-invoice-feature, .custlo-t1-invoice-download-from-preview";
    const invoiceTextColor = "#3c1413";
    const invoiceFont = "Arial, Helvetica, sans-serif";

    function prepareInvoiceForPdf(root) {
        const scope = root && root.querySelectorAll ? root : document;
        const invoices = [];

        if (scope.matches && scope.matches(invoiceSelector)) invoices.push(scope);
        scope.querySelectorAll(invoiceSelector).forEach(function (invoice) {
            invoices.push(invoice);
        });

        invoices.forEach(function (invoice) {
            invoice.style.setProperty("color", invoiceTextColor, "important");
            invoice.style.setProperty("-webkit-text-fill-color", invoiceTextColor, "important");
            invoice.style.setProperty("font-family", invoiceFont, "important");
            invoice.style.setProperty("opacity", "1", "important");
            invoice.style.setProperty("visibility", "visible", "important");
            invoice.style.setProperty("background", "#ffffff", "important");
            invoice.style.setProperty("--custlo-t1-text-main", invoiceTextColor);
            invoice.style.setProperty("--custlo-t1-text-muted", invoiceTextColor);
            invoice.style.setProperty("--custlo-t1-heading-color", invoiceTextColor);

            invoice.querySelectorAll("*").forEach(function (element) {
                element.style.setProperty("color", invoiceTextColor, "important");
                element.style.setProperty("-webkit-text-fill-color", invoiceTextColor, "important");
                element.style.setProperty("font-family", invoiceFont, "important");
                element.style.setProperty("opacity", "1", "important");
                element.style.setProperty("visibility", "visible", "important");
                element.style.setProperty("text-shadow", "none", "important");
            });

            invoice.querySelectorAll("svg text, svg tspan").forEach(function (element) {
                element.setAttribute("fill", invoiceTextColor);
                element.style.setProperty("fill", invoiceTextColor, "important");
            });
        });
    }

    document.addEventListener("pointerdown", function (event) {
        if (!event.target.closest(invoiceDownloadSelector)) return;
        prepareInvoiceForPdf(document);
    }, true);

    document.addEventListener("click", function (event) {
        if (!event.target.closest(invoiceDownloadSelector)) return;
        prepareInvoiceForPdf(document);
    }, true);

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) prepareInvoiceForPdf(node);
            });
        });
    });

    prepareInvoiceForPdf(document);
    observer.observe(document.body, { childList: true, subtree: true });
});

// Custlo empty orders collection link ========================
document.addEventListener("DOMContentLoaded", function () {
    const emptyOrdersSelector = ".custlo-t1-empty-orders";
    const oldPath = "/collections/all";
    const newPath = "/collections/shop";

    function updateEmptyOrdersLink(root) {
        const scope = root && root.querySelectorAll ? root : document;
        const links = [];

        if (scope.matches && scope.matches(emptyOrdersSelector + " a[href]")) links.push(scope);
        scope.querySelectorAll(emptyOrdersSelector + " a[href]").forEach(function (link) {
            links.push(link);
        });

        links.forEach(function (link) {
            const href = link.getAttribute("href");
            if (href === oldPath || href === oldPath + "/") {
                link.setAttribute("href", newPath);
            }
        });
    }

    updateEmptyOrdersLink(document);

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) updateEmptyOrdersLink(node);
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

// Custlo order list product title ========================
document.addEventListener("DOMContentLoaded", function () {
    const titleClass = "four-custlo-order-product-title";
    const addressClass = "four-custlo-order-address";
    const orderLabelClass = "four-custlo-order-id-label";
    const addressCache = {};
    const addressRequests = {};

    function safeJson(value, fallback) {
        if (!value) return fallback;
        try {
            return JSON.parse(value);
        } catch (error) {
            return fallback;
        }
    }

    function cleanTitle(value) {
        const title = String(value || "").replace(/\s+/g, " ").trim();
        if (!title || /^(product|image|no image)$/i.test(title)) return "";
        return title;
    }

    function cleanText(value) {
        return String(value || "").replace(/\s+/g, " ").trim();
    }

    function cleanAddressText(value) {
        const address = String(value || "")
            .replace(/\r/g, "\n")
            .split("\n")
            .map(cleanText)
            .filter(function (line) {
                return line && !/^(default\s+)?address$/i.test(line);
            })
            .slice(-3)
            .join(" ");

        return address
            .replace(/^[A-Za-zÀ-ÿ' -]+?\s+((?:Rue|Street|St\.?|Avenue|Ave\.?|Road|Rd\.?|Lane|Ln\.?|Drive|Dr\.?|Boulevard|Blvd\.?|Way|Place|Pl\.?|Court|Ct\.?|Square|Sq\.?|Highway|Hwy\.?|Calle|Via|Viale|Strada|Straat|Laan|Chemin|Quai|All[ée]e|Avenida|Carrer|Gasse|Weg|Ring)\b)/i, "$1")
            .replace(/^[A-Za-zÀ-ÿ'-]+\s+[A-Za-zÀ-ÿ'-]+\s+(\d+\s+\S+)/, "$1")
            .trim();
    }

    function orderNumberValue(value) {
        return cleanText(value).replace(/^order\s*id\s*/i, "").replace(/^#/, "");
    }

    function titleFromItems(items) {
        if (!Array.isArray(items) || !items.length) return "";

        const title = cleanTitle(
            items[0].title ||
            items[0].product_title ||
            items[0].name ||
            items[0].productName
        );

        if (!title) return "";
        return items.length > 1 ? title + " +" + (items.length - 1) : title;
    }

    function titleFromDataset(orderItem) {
        const lineItemsSource = orderItem.querySelector("[data-line-items]");
        const lineItemsTitle = titleFromItems(safeJson(lineItemsSource ? lineItemsSource.dataset.lineItems : "", []));
        if (lineItemsTitle) return lineItemsTitle;

        const orderSource = orderItem.querySelector("[data-four-sendcloud-order]");
        const orderData = safeJson(orderSource ? orderSource.dataset.fourSendcloudOrder : "", {});
        return titleFromItems(orderData && orderData.lineItems);
    }

    function titleFromImage(orderItem) {
        const image = orderItem.querySelector(".custlo-t1-order-main_line_item_img img");
        if (!image) return "";

        return cleanTitle(
            image.getAttribute("alt") ||
            image.getAttribute("title") ||
            image.getAttribute("aria-label")
        );
    }

    function orderTitle(orderItem) {
        return titleFromDataset(orderItem) || titleFromImage(orderItem);
    }

    function uniqueValues(values) {
        return values.filter(function (value, index, list) {
            return value && list.indexOf(value) === index;
        });
    }

    function addressFromObject(value) {
        if (!value || typeof value !== "object") return "";

        const address = value.shipping_address ||
            value.shippingAddress ||
            value.delivery_address ||
            value.deliveryAddress ||
            value.billing_address ||
            value.billingAddress ||
            value.address ||
            value;

        if (typeof address === "string") return cleanAddressText(address);
        if (!address || typeof address !== "object") return "";

        return uniqueValues([
            cleanText(address.address1 || address.address_1 || address.address),
            cleanText(address.address2 || address.address_2),
            cleanText(address.city),
            cleanText(address.province || address.province_code || address.state || address.state_code),
            cleanText(address.zip || address.postal_code || address.postcode),
            cleanText(address.country || address.country_name || address.country_code)
        ]).join(", ");
    }

    function addressFromDatasets(orderItem) {
        const elements = [orderItem].concat(Array.from(orderItem.querySelectorAll("*")));
        let address = "";

        elements.some(function (element) {
            return Object.keys(element.dataset || {}).some(function (key) {
                const lowerKey = key.toLowerCase();
                if (!/(address|shipping|delivery|billing)/.test(lowerKey)) return false;

                const rawValue = element.dataset[key];
                const parsedValue = safeJson(rawValue, null);
                address = addressFromObject(parsedValue);

                if (!address && lowerKey.indexOf("address") !== -1) {
                    address = cleanAddressText(rawValue);
                }

                return Boolean(address);
            });
        });

        return address;
    }

    function addressFromDetailBlock(block) {
        if (!block) return "";

        const labelElement = block.querySelector("h1,h2,h3,h4,h5,h6,label,span,strong");
        const heading = cleanText(labelElement ? labelElement.textContent : "");

        if (!/(address|shipping|delivery|billing)/i.test(heading)) return "";

        const clone = block.cloneNode(true);
        if (labelElement) {
            const labels = clone.querySelectorAll("h1,h2,h3,h4,h5,h6,label,span,strong");
            if (labels[0]) labels[0].remove();
        }
        clone.querySelectorAll("button,svg").forEach(function (element) {
            element.remove();
        });

        return cleanAddressText(clone.textContent);
    }

    function orderNumberFromElement(element) {
        if (!element) return "";

        const ownOrder = element.querySelector(".custlo-t1-order-number");
        if (ownOrder) return orderNumberValue(ownOrder.textContent);

        const text = cleanText(element.textContent);
        const match = text.match(/(?:order\s*id\s*)?#\s*([A-Za-z0-9-]+)/i);
        return match ? orderNumberValue(match[1]) : "";
    }

    function cacheOrderDetailAddresses(scope) {
        const root = scope && scope.querySelectorAll ? scope : document;
        const detailSelector = '[id*="order"][id*="detail"], [class*="order-detail"], [class*="custlo-t1-sh2"]';
        const detailRoots = new Set();

        if (root.matches && root.matches(detailSelector)) {
            detailRoots.add(root);
        }

        root.querySelectorAll(detailSelector).forEach(function (detailRoot) {
            detailRoots.add(detailRoot);
        });

        root.querySelectorAll(".custlo-t1-sh2-info-block, .custlo-t1-info-row, .custlo-t1-address-format, [class*='address']").forEach(function (block) {
            detailRoots.add(block.closest('[id*="order"][id*="detail"], [class*="order-detail"], .custlo-t1-view, [id*="view"]') || block);
        });

        detailRoots.forEach(function (detailRoot) {
            const orderNumber = orderNumberFromElement(detailRoot);
            if (!orderNumber) return;

            let address = "";
            const directAddress = detailRoot.querySelector(".custlo-t1-address-format");
            if (directAddress) {
                address = cleanAddressText(directAddress.textContent);
            }

            if (!address) {
                detailRoot.querySelectorAll(".custlo-t1-sh2-info-block, .custlo-t1-info-row, [class*='address']").forEach(function (block) {
                    if (address) return;
                    address = addressFromDetailBlock(block);
                });
            }

            if (address) {
                addressCache[orderNumber] = address;
            }
        });
    }

    function firstDetailAddress(scope) {
        const root = scope && scope.querySelectorAll ? scope : document;
        let address = "";
        const directAddress = root.querySelector(".custlo-t1-address-format");

        if (directAddress) {
            address = cleanAddressText(directAddress.textContent);
        }

        if (!address) {
            root.querySelectorAll(".custlo-t1-sh2-info-block, .custlo-t1-info-row, [class*='address']").forEach(function (block) {
                if (address) return;
                address = addressFromDetailBlock(block);
            });
        }

        return address;
    }

    function detailUrlFromOrder(orderItem) {
        const button = orderItem.querySelector(".custlo-t1-order-view-btn[href], .custlo-t1-order-view-btn[data-route], [data-route*='order']");
        const rawUrl = button && (button.getAttribute("href") || button.dataset.route);
        if (!rawUrl || rawUrl === "#" || /^javascript:/i.test(rawUrl)) return "";

        try {
            const url = new URL(rawUrl, window.location.origin);
            if (url.origin !== window.location.origin) return "";
            return url.href;
        } catch (error) {
            return "";
        }
    }

    function requestOrderAddress(orderItem, orderNumber) {
        if (!orderNumber || addressCache[orderNumber] || addressRequests[orderNumber]) return;

        const detailUrl = detailUrlFromOrder(orderItem);
        if (!detailUrl) return;

        addressRequests[orderNumber] = true;

        fetch(detailUrl, {
            credentials: "same-origin",
            headers: { "Accept": "text/html" }
        })
            .then(function (response) {
                if (!response.ok) throw new Error("Order detail address unavailable.");
                return response.text();
            })
            .then(function (html) {
                const detailDocument = new DOMParser().parseFromString(html, "text/html");
                cacheOrderDetailAddresses(detailDocument);

                if (!addressCache[orderNumber]) {
                    const address = firstDetailAddress(detailDocument);
                    if (address) addressCache[orderNumber] = address;
                }

                syncOrderProductTitles(document);
            })
            .catch(function () {
                addressRequests[orderNumber] = "failed";
            });
    }

    function syncOrderIdLabel(orderItem) {
        const orderNumber = orderItem.querySelector(".custlo-t1-order-number");
        if (!orderNumber || orderNumber.querySelector("." + orderLabelClass)) return;
        if (/^\s*order\s*id\b/i.test(orderNumber.textContent || "")) return;

        const label = document.createElement("span");
        label.className = orderLabelClass;
        label.textContent = "Order Id ";
        orderNumber.prepend(label);
    }

    function syncOrderProductTitles(scope) {
        const root = scope && scope.nodeType === 1 ? scope : document;
        const orderItems = [];

        if (root.matches && root.matches(".custlo-t1-order-item")) {
            orderItems.push(root);
        }

        root.querySelectorAll(".custlo-t1-order-item").forEach(function (orderItem) {
            orderItems.push(orderItem);
        });

        orderItems.forEach(function (orderItem) {
            const title = orderTitle(orderItem);
            const orderNumber = orderNumberFromElement(orderItem);
            const address = addressFromDatasets(orderItem) || addressCache[orderNumber] || "";
            const meta = orderItem.querySelector(".custlo-t1-order-meta");
            if (!meta) return;

            syncOrderIdLabel(orderItem);
            requestOrderAddress(orderItem, orderNumber);

            if (title) {
                let titleElement = orderItem.querySelector("." + titleClass);
                if (!titleElement) {
                    titleElement = document.createElement("div");
                    titleElement.className = titleClass;
                    meta.insertAdjacentElement("afterend", titleElement);
                }

                if (titleElement.textContent !== title) {
                    titleElement.textContent = title;
                }
            }

            let addressElement = orderItem.querySelector("." + addressClass);
            if (!address) {
                if (addressElement) addressElement.remove();
                return;
            }

            if (!addressElement) {
                addressElement = document.createElement("div");
                addressElement.className = addressClass;
                const titleElement = orderItem.querySelector("." + titleClass);
                (titleElement || meta).insertAdjacentElement("afterend", addressElement);
            }

            if (addressElement.textContent !== address) {
                addressElement.textContent = address;
            }
        });
    }

    cacheOrderDetailAddresses(document);
    syncOrderProductTitles(document);

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === "attributes" && mutation.target.nodeType === 1) {
                cacheOrderDetailAddresses(mutation.target.closest('[id*="order"][id*="detail"], [class*="order-detail"], [class*="custlo-t1-sh2"]') || mutation.target);
                syncOrderProductTitles(document);
                return;
            }

            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                    cacheOrderDetailAddresses(node);
                    syncOrderProductTitles(document);
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
            "data-line-items",
            "data-four-sendcloud-order",
            "data-address",
            "data-shipping-address",
            "data-delivery-address",
            "data-billing-address",
            "alt",
            "title",
            "aria-label"
        ]
    });
});

// header menu start ========================
jQuery(function ($) {
    const $header = $('header');
    if (!$header.length) return;

    // sticky header on scroll > 2px
    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 2) {
            $header.addClass('sticky');
        } else {
            $header.removeClass('sticky');
        }
    });

    // hide on scroll down, show on scroll up
    let didScroll = false;
    let last = $(window).scrollTop();
    const delta = 5;

    $(window).on('scroll', function () {
        didScroll = true;
    });

    setInterval(function () {
        if (!didScroll) return;
        if ($header.hasClass('toggled')) {
            didScroll = false;
            return;
        }
        const st = $(window).scrollTop();
        const navH = $header.outerHeight() || 0;

        if (Math.abs(last - st) > delta) {
            if (st > last && st > navH) {
                $header.removeClass('nav-down').addClass('nav-up');
            } else if (st + $(window).height() < $(document).height()) {
                $header.removeClass('nav-up').addClass('nav-down');
            }
            last = st;
        }
        didScroll = false;
    }, 250);
});

// gift card product recipient checkout ===============================
document.addEventListener("DOMContentLoaded", function () {
    const giftCardRoot = document.querySelector("[data-gift-card-product]");
    if (!giftCardRoot) return;

    const form = giftCardRoot.querySelector("[data-gift-card-form]");
    const status = giftCardRoot.querySelector("[data-gift-card-status]");
    const submitButton = giftCardRoot.querySelector("[data-gift-card-submit]");
    const recipientEnabled = giftCardRoot.querySelector("[data-recipient-enabled]");
    const recipientName = giftCardRoot.querySelector("[data-recipient-name]");
    const recipientEmail = giftCardRoot.querySelector("[data-recipient-email]");
    const recipientMessage = giftCardRoot.querySelector("[data-recipient-message]");
    const selfMessage = giftCardRoot.querySelector("[data-self-message]");
    const variantInput = giftCardRoot.querySelector("[data-gift-card-variant-id]");

    if (!form || !submitButton) return;

    function isRecipientMode() {
        const activeTab = giftCardRoot.querySelector("[data-gift-card-mode].active");
        return !activeTab || activeTab.dataset.giftCardMode === "recipient";
    }

    function syncGiftCardFields() {
        const recipientMode = isRecipientMode();

        if (recipientEnabled) {
            recipientEnabled.disabled = !recipientMode;
        }
        if (recipientName) {
            recipientName.disabled = !recipientMode;
            recipientName.required = recipientMode;
        }
        if (recipientEmail) {
            recipientEmail.disabled = !recipientMode;
            recipientEmail.required = recipientMode;
        }
        if (recipientMessage) {
            recipientMessage.disabled = !recipientMode;
            recipientMessage.name = recipientMode ? "properties[Message]" : "";
        }
        if (selfMessage) {
            selfMessage.disabled = recipientMode;
            selfMessage.name = recipientMode ? "" : "properties[Message]";
        }
    }

    giftCardRoot.querySelectorAll("[data-gift-card-mode]").forEach(function (tab) {
        tab.addEventListener("shown.bs.tab", syncGiftCardFields);
        tab.addEventListener("click", function () {
            window.setTimeout(syncGiftCardFields, 0);
        });
    });

    syncGiftCardFields();

    giftCardRoot.querySelectorAll("[data-gift-card-variant]").forEach(function (variantButton) {
        variantButton.addEventListener("click", function () {
            giftCardRoot.querySelectorAll("[data-gift-card-variant]").forEach(function (button) {
                button.classList.remove("active");
                button.setAttribute("aria-pressed", "false");
            });

            variantButton.classList.add("active");
            variantButton.setAttribute("aria-pressed", "true");

            if (variantInput && variantButton.dataset.variantId) {
                variantInput.value = variantButton.dataset.variantId;
            }
        });
    });

    form.addEventListener("submit", function (event) {
        event.preventDefault();
        syncGiftCardFields();

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        const defaultLabel = submitButton.textContent;
        submitButton.disabled = true;
        submitButton.textContent = "Adding...";
        if (status) status.textContent = "";

        fetch(form.action + ".js", {
            method: "POST",
            body: new FormData(form),
            headers: {
                "Accept": "application/json"
            }
        })
            .then(function (response) {
                if (!response.ok) {
                    return response.json().then(function (data) {
                        throw new Error(data.description || data.message || "Unable to add gift card");
                    });
                }
                return response.json();
            })
            .then(function () {
                submitButton.disabled = false;
                submitButton.textContent = defaultLabel;
                syncGiftCardFields();
                if (window.FourCartDrawer && typeof window.FourCartDrawer.refreshAndOpen === "function") {
                    window.FourCartDrawer.refreshAndOpen();
                    return;
                }
                window.location.href = "/cart";
            })
            .catch(function (error) {
                submitButton.disabled = false;
                submitButton.textContent = defaultLabel;
                if (status) {
                    status.textContent = error.message || "Unable to add gift card. Please try again.";
                }
            });
    });
});

$(document).ready(function () {
    function closeMobileMegaSubmenus() {
        $('.mega-menu__categories li').removeClass('is-active');
        $('.mega-submenu--mobile').slideUp(180, function () {
            $(this).remove();
        });
    }

    function syncMegaMenuStateByViewport() {
        if (window.innerWidth <= 767) {
            closeMobileMegaSubmenus();
            $('.mega-submenu').removeClass('is-active');
            return;
        }

        var $defaultItem = $('.mega-menu__categories li').first();
        if ($defaultItem.length) {
            setActiveMegaMenu($defaultItem);
        }
    }

    function openMegaMenu() {
        if (window.innerWidth <= 767) return;
        $('#shopMegaMenu').addClass('is-open');
    }

    function closeMegaMenu() {
        $('#shopMegaMenu').removeClass('is-open');
    }

    $('.has-mega-menu').on('mouseenter focusin', function () {
        openMegaMenu();
    });

    $('.has-mega-menu').on('mouseleave', function () {
        if (window.innerWidth > 767) {
            closeMegaMenu();
        }
    });

    $('.js-mega-toggle').on('click', function (e) {
        if (window.innerWidth <= 767) {
            e.preventDefault();
            $('#shopMegaMenu').toggleClass('is-open');
        }
    });

    $('.mega-menu__close').on('click', function () {
        closeMegaMenu();
    });

    function setActiveMegaMenu($item) {
        var menuName = $item.data('menu');
        $('.mega-menu__categories li').removeClass('is-active');
        $item.addClass('is-active');
        $('.mega-submenu').removeClass('is-active');
        $('.mega-submenu[data-submenu="' + menuName + '"]').addClass('is-active');
    }

    $('.mega-menu__categories li').on('mouseenter', function () {
        if (window.innerWidth > 767) {
            setActiveMegaMenu($(this));
        }
    });

    $('.mega-menu__categories li').on('click', function (e) {
        var $li = $(this);

        if (window.innerWidth <= 767) {
            var $target = $(e.target);
            var $mainLink = $li.children('a').first();
            var $toggle = $li.children('span').first();

            var clickedMainLink =
                $mainLink.length &&
                $target.closest('a').length &&
                $target.closest('a')[0] === $mainLink[0];

            if (clickedMainLink) {
                return;
            }

            var clickedToggle =
                $toggle.length &&
                ($target[0] === $toggle[0] || $.contains($toggle[0], $target[0]));

            if (clickedToggle) {
                e.preventDefault();
                e.stopPropagation();

                var submenuName = $li.data('menu');
                var $sourceSubmenu = $('.mega-submenu[data-submenu="' + submenuName + '"]');

                if ($li.hasClass('is-active')) {
                    closeMobileMegaSubmenus();
                    return;
                }

                closeMobileMegaSubmenus();
                $li.addClass('is-active');

                if ($sourceSubmenu.length) {
                    $('<ul class="mega-submenu--mobile"></ul>')
                        .html($sourceSubmenu.html())
                        .appendTo($li)
                        .hide()
                        .slideDown(180);
                }
                return;
            }

            return;
        }

        if ($(e.target).closest('a').length) {
            return;
        }

        e.preventDefault();
        setActiveMegaMenu($li);
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.site-header').length) {
            closeMegaMenu();
            closeMobileMegaSubmenus();
        }
    });

    $(document).on('keydown.megaMenuEsc', function (e) {
        if (e.key === 'Escape') {
            closeMegaMenu();
            closeMobileMegaSubmenus();
        }
    });

    $(window).on('resize', function () {
        syncMegaMenuStateByViewport();
    });

    syncMegaMenuStateByViewport();

});
jQuery(function ($) {
    // Menu toggle button functionality
    const $nav = $('#toggleMenu');
    const $toggleBtn = $nav.find('.menu-toggle');
    const $menu = $('#primary-menu');

    if ($toggleBtn.length) {
        $toggleBtn.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const isExpanded = $toggleBtn.attr('aria-expanded') === 'true';

            // Toggle classes
            $nav.toggleClass('toggled');
            $('body, html').toggleClass('mobile-nav-open');

            // Toggle aria-expanded
            $toggleBtn.attr('aria-expanded', !isExpanded);

            if ($nav.hasClass('toggled')) {
                $nav.removeClass('nav-up').addClass('nav-down');

                const $sp = $('#headerSearchPopup');
                if ($sp.length) {
                    $sp.removeClass('is-open').attr('aria-hidden', 'true');
                    $('body').removeClass('mobile-search-open');
                    $('#headerSearchTrigger').attr('aria-expanded', 'false');
                }
            }
        });
    }

    const $searchPopup = $('#headerSearchPopup');
    const $searchTrigger = $('#headerSearchTrigger');
    if ($searchTrigger.length && $searchPopup.length) {
        function closeHeaderSearch() {
            $searchPopup.removeClass('is-open').attr('aria-hidden', 'true');
            $('body').removeClass('mobile-search-open');
            $searchTrigger.attr('aria-expanded', 'false');
        }
        function openHeaderSearch() {
            if ($toggleBtn.length) {
                $nav.removeClass('toggled');
                $('body, html').removeClass('mobile-nav-open');
                $toggleBtn.attr('aria-expanded', 'false');
            }
            $searchPopup.addClass('is-open').attr('aria-hidden', 'false');
            $('body').addClass('mobile-search-open');
            $searchTrigger.attr('aria-expanded', 'true');
            setTimeout(function () {
                $searchPopup.find('#headerSearchInput').trigger('focus');
            }, 100);
        }
        $searchTrigger.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if ($searchPopup.hasClass('is-open')) {
                closeHeaderSearch();
            } else {
                openHeaderSearch();
            }
        });
        $searchPopup.find('[data-close-search]').on('click', function (e) {
            e.preventDefault();
            closeHeaderSearch();
        });
        $(document).on('keydown.headerSearchEsc', function (e) {
            if (e.key === 'Escape' && $searchPopup.hasClass('is-open')) {
                closeHeaderSearch();
            }
        });
    }

    function initPredictiveSearch() {
        var searchBlocks = document.querySelectorAll('[data-predictive-search]');
        var popupPanel = document.querySelector('.header-search-popup__panel');
        if (popupPanel && !popupPanel.hasAttribute('data-predictive-search')) {
            popupPanel.setAttribute('data-predictive-search', '');
        }

        document.querySelectorAll('[data-predictive-search]').forEach(function (block) {
            var form = block.querySelector('form[role="search"]');
            var input = block.querySelector('[data-predictive-search-input]');
            var results = block.querySelector('[data-predictive-search-results]');
            var timer = null;
            var controller = null;

            if (!form || !input || !results) return;

            function escapeHtml(value) {
                return String(value || '').replace(/[&<>"']/g, function (char) {
                    return {
                        '&': '&amp;',
                        '<': '&lt;',
                        '>': '&gt;',
                        '"': '&quot;',
                        "'": '&#39;'
                    }[char];
                });
            }

            function formatMoney(cents) {
                var amount = Number(cents);
                if (!Number.isFinite(amount)) return '';
                var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
                    ? window.Shopify.currency.active
                    : 'EUR';
                return new Intl.NumberFormat(document.documentElement.lang || 'en', {
                    style: 'currency',
                    currency: currency
                }).format(amount / 100);
            }

            function setResults(html) {
                results.innerHTML = html;
                results.hidden = false;
            }

            function hideResults() {
                results.hidden = true;
                results.innerHTML = '';
            }

            function renderProducts(products, query) {
                if (!products.length) {
                    setResults('<p class="predictive-search__status">No products found.</p>');
                    return;
                }

                var items = products.map(function (product) {
                    var image = product.image
                        ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
                        : '<span class="predictive-search__placeholder">No image</span>';
                    var price = product.price_min != null ? formatMoney(product.price_min) : '';

                    return '' +
                        '<li class="predictive-search__item">' +
                            '<a class="predictive-search__link" href="' + escapeHtml(product.url) + '">' +
                                '<span class="predictive-search__image">' + image + '</span>' +
                                '<span class="predictive-search__content">' +
                                    '<span class="predictive-search__title">' + escapeHtml(product.title) + '</span>' +
                                    (price ? '<span class="predictive-search__price">' + escapeHtml(price) + '</span>' : '') +
                                '</span>' +
                            '</a>' +
                        '</li>';
                }).join('');

                var viewAllUrl = form.getAttribute('action') + '?type=product&q=' + encodeURIComponent(query);
                setResults(
                    '<ul class="predictive-search__list">' + items + '</ul>' +
                    '<a class="predictive-search__view-all" href="' + escapeHtml(viewAllUrl) + '">View all results</a>'
                );
            }

            function fetchSuggestions(query) {
                if (controller) controller.abort();
                controller = new AbortController();

                var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

                setResults('<p class="predictive-search__status">Searching...</p>');

                fetch(url, {
                    signal: controller.signal,
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                    .then(function (response) {
                        if (!response.ok) throw new Error('Search request failed');
                        return response.json();
                    })
                    .then(function (data) {
                        var products = data && data.resources && data.resources.results && data.resources.results.products
                            ? data.resources.results.products
                            : [];
                        renderProducts(products, query);
                    })
                    .catch(function (error) {
                        if (error.name === 'AbortError') return;
                        setResults('<p class="predictive-search__status">Unable to load suggestions.</p>');
                    });
            }

            input.addEventListener('input', function () {
                var query = input.value.trim();
                window.clearTimeout(timer);

                if (query.length < 2) {
                    hideResults();
                    return;
                }

                timer = window.setTimeout(function () {
                    fetchSuggestions(query);
                }, 250);
            });

            input.addEventListener('focus', function () {
                var query = input.value.trim();
                if (query.length >= 2 && results.innerHTML.trim() !== '') {
                    results.hidden = false;
                }
            });

            form.addEventListener('submit', function (event) {
                if (input.value.trim() === '') {
                    event.preventDefault();
                    input.focus();
                }
            });
        });

        document.addEventListener('click', function (event) {
            document.querySelectorAll('[data-predictive-search]').forEach(function (block) {
                if (!block.contains(event.target)) {
                    var results = block.querySelector('[data-predictive-search-results]');
                    if (results) results.hidden = true;
                }
            });
        });
    }

    initPredictiveSearch();

});
// header menu end ========================



$(document).ready(function () {

    /* ========================= banner section start ======================= */
    var slideCount = $('.ef-hero-slider .swiper-slide').length;

    if (slideCount > 1) {
        new Swiper('.ef-hero-slider', {
            loop: true,
            speed: 1000,
            effect: 'fade',
            autoplay: {
                delay: 3500,
                disableOnInteraction: false
            },
            pagination: {
                el: '.ef-hero-pagination',
                clickable: true
            }
        });
    } else {
        $('.ef-hero-slider').addClass('single-image');
        $('.ef-hero-pagination').hide();
    }

    /* ========================= category section start ======================= */
    var categorySwiper;

    function initCategorySlider() {
        var windowWidth = $(window).width();

        if (windowWidth < 992 && !categorySwiper) {
            categorySwiper = new Swiper('.category-slider', {
                loop: false,
                spaceBetween: 14,
                slidesPerView: 4,
                breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 6,
                    },
                    576: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                        loop: false,
                        autoplay: {
                            delay: 3500,
                            disableOnInteraction: false,
                            enabled: true,
                        },
                    },
                    992: {
                        slidesPerView: 4,
                    }
                }
            });
        }

        if (windowWidth > 992 && categorySwiper) {
            categorySwiper.destroy(true, true);
            categorySwiper = undefined;
        }
    }

    initCategorySlider();

    $(window).on('resize', function () {
        initCategorySlider();
    });

    /* ========================= favourites section start ======================= */
    new Swiper('.favourites-slider', {
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: '.fav-next',
            prevEl: '.fav-prev'
        }
    });


    /* ========================= founder section start ======================= */
    var founderSwiper;

    function initFounderSlider() {
        var windowWidth = $(window).width();

        if (windowWidth < 992 && !founderSwiper) {
            founderSwiper = new Swiper('.founder-slider', {
                loop: false,
                spaceBetween: 14,
                slidesPerView: 4,
                breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 6,
                    },
                    576: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                        loop: true,
                        autoplay: {
                            delay: 3500,
                            disableOnInteraction: false,
                            enabled: true,
                        },
                    },
                    992: {
                        slidesPerView: 4,
                    }
                }
            });
        }

        if (windowWidth > 992 && founderSwiper) {
            founderSwiper.destroy(true, true);
            founderSwiper = undefined;
        }
    }

    initFounderSlider();

    $(window).on('resize', function () {
        initFounderSlider();
    });

    // select 2 ================================
    $(document).ready(function () {
        $('.custom-select2').select2({
            minimumResultsForSearch: Infinity,
            width: '100%'
        });
    });

    // brand panel swiper ========================
    var brandSwiper;

    function initBrandSwiper() {
        if (!$('.brand-swiper').length) {
            return;
        }

        brandSwiper = new Swiper('.brand-swiper', {
            slidesPerView: 6,
            spaceBetween: 14,
            speed: 500,
            navigation: {
                nextEl: '.brand-next',
                prevEl: '.brand-prev'
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.2
                },
                576: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                992: {
                    slidesPerView: 4
                },
                1200: {
                    slidesPerView: 5
                },
                1400: {
                    slidesPerView: 6
                }
            }
        });
    }

    initBrandSwiper();

    // filter dropdown start ========================
    $('.dropdown-toggle-btn').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var parentDropdown = $(this).closest('.toolbar-dropdown');
        var toolbarWrap = parentDropdown.closest('.product-toolbar-wrap');
        var isBrandDropdown = parentDropdown.hasClass('brand-dropdown');

        $('.toolbar-dropdown').not(parentDropdown).removeClass('is-open');
        $('.product-toolbar-wrap').not(toolbarWrap).removeClass('is-open');

        parentDropdown.toggleClass('is-open');

        if (isBrandDropdown) {
            toolbarWrap.toggleClass('is-open', parentDropdown.hasClass('is-open'));
            if (parentDropdown.hasClass('is-open') && brandSwiper) {
                setTimeout(function () {
                    brandSwiper.update();
                }, 0);
            }
        } else {
            toolbarWrap.removeClass('is-open');
            toolbarWrap.find('.brand-dropdown').removeClass('is-open');
        }
    });

    $('.toolbar-menu-option').on('click', function () {
        var selectedValue = $(this).text();
        var parentDropdown = $(this).closest('.toolbar-dropdown');

        parentDropdown.find('.toolbar-menu-option').removeClass('active');
        $(this).addClass('active');

        parentDropdown.find('.selected-text').text(selectedValue);
        parentDropdown.removeClass('is-open');
    });

    function setCurrencySelection(code) {
        if (!code) return;

        $('.currency-dropdown [data-currency-option]').each(function () {
            const option = $(this);
            option.toggleClass('active', option.data('currency-code') === code);
        });

        const activeOption = $('.currency-dropdown [data-currency-option][data-currency-code="' + code + '"]');
        if (activeOption.length) {
            $('.currency-dropdown [data-currency-selected]').text(activeOption.text().trim());
        }
    }

    $('.currency-dropdown [data-currency-option]').on('click', function () {
        const option = $(this);
        const currencyCode = option.data('currency-code');
        const countryCode = option.data('country-code');
        const localizationForm = document.getElementById('FourCurrencyLocalizationForm');
        const countryInput = localizationForm ? localizationForm.querySelector('[data-four-currency-country]') : null;
        const returnInput = localizationForm ? localizationForm.querySelector('[name="return_to"]') : null;

        if (!currencyCode || !countryCode || !localizationForm || !countryInput) return;

        setCurrencySelection(currencyCode);

        if (countryInput.value === countryCode) return;
        countryInput.value = countryCode;
        if (returnInput) {
            returnInput.value = window.location.pathname + window.location.search;
        }
        localizationForm.submit();
    });

    // Read the menu rendered by the header so every collection uses the same
    // category order and Shopify navigation links, without a fallback list.
    function syncFilterCategoryMenu() {
        const menuTemplate = document.getElementById('filterCategoryMenu');
        const menuTarget = document.querySelector('[data-filter-category-menu]');
        if (!menuTemplate || !menuTarget) return;

        menuTarget.replaceChildren(menuTemplate.content.cloneNode(true));
    }

    syncFilterCategoryMenu();
    document.addEventListener('shopify:section:load', syncFilterCategoryMenu);

    $('.filter-group-title').on('click', function () {
        var group = $(this).closest('.filter-group');

        group.toggleClass('is-open');
        group.find('.filter-group-content').slideToggle(250);

        if (group.hasClass('is-open')) {
            $(this).find('strong').text('−');
        } else {
            $(this).find('strong').text('+');
        }
    });

    $(document).on('click', function () {
        $('.toolbar-dropdown').removeClass('is-open');
        $('.product-toolbar-wrap').removeClass('is-open');
    });

    $('.toolbar-menu, .brand-panel').on('click', function (e) {
        e.stopPropagation();
    });
});

// product detail page slider, gallery and variants start ===============================
document.addEventListener("DOMContentLoaded", function () {
    const productDetail = document.querySelector("[data-product-detail]");
    if (!productDetail) return;

    const productJsonEl = productDetail.querySelector("[data-product-json]");
    const gallery = productDetail.querySelector("[data-product-gallery]");
    const galleryTemplates = productDetail.querySelector(".product-gallery-templates");
    const priceEl = productDetail.querySelector("[data-product-price]");
    const variantInput = productDetail.querySelector("[data-selected-variant-id]");
    const variantSelect = productDetail.querySelector("[data-product-variants-select]");
    const sizeMessage = productDetail.querySelector("[data-size-message]");
    const productActions = productDetail.querySelector(".product-actions");
    const backInStockTarget = productDetail.querySelector("[data-back-in-stock-target]");
    const wishlistButtons = productDetail.querySelectorAll("[data-wishList][data-varID]");
    const addToCartButton = productDetail.querySelector("[data-add-to-cart]");
    const buyNowButton = productDetail.querySelector("[data-buy-now]");
    let productData = null;

    try {
        productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    } catch (error) {
        productData = null;
    }

    function syncCombinedListingFallback() {
        const fallbackSwatches = productDetail.querySelectorAll("[data-product-split-swatches]");
        const appTarget = productDetail.querySelector("[data-vcl-groups-priority]");
        if (!fallbackSwatches.length || !appTarget) return;

        fallbackSwatches.forEach(function (fallbackSwatch) {
            fallbackSwatch.hidden = Boolean(appTarget.innerHTML.trim());
        });
    }

    syncCombinedListingFallback();
    const combinedListingTarget = productDetail.querySelector("[data-vcl-groups-priority]");
    if (combinedListingTarget && window.MutationObserver) {
        new MutationObserver(syncCombinedListingFallback).observe(combinedListingTarget, {
            childList: true,
            subtree: true
        });
    }

    function formatMoney(cents) {
        const value = Number(cents || 0) / 100;
        const amount = value.toFixed(2);
        const amountWithCommaSeparator = amount.replace(".", ",");
        const amountNoDecimals = String(Math.round(value));
        const amountNoDecimalsWithCommaSeparator = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const amountWithThousands = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        if (productData && productData.currencySymbol) {
            return productData.currencySymbol + amountWithThousands;
        }

        if (!productData || !productData.moneyFormat) return amount;
        return productData.moneyFormat
            .replace("{{amount}}", amount)
            .replace("{{ amount }}", amount)
            .replace("{{amount_with_comma_separator}}", amountWithCommaSeparator)
            .replace("{{ amount_with_comma_separator }}", amountWithCommaSeparator)
            .replace("{{amount_no_decimals}}", amountNoDecimals)
            .replace("{{ amount_no_decimals }}", amountNoDecimals)
            .replace("{{amount_no_decimals_with_comma_separator}}", amountNoDecimalsWithCommaSeparator)
            .replace("{{ amount_no_decimals_with_comma_separator }}", amountNoDecimalsWithCommaSeparator);
    }

    function getSelectedColor() {
        const activeColor = productDetail.querySelector(".color-thumb.active");
        return activeColor ? activeColor.dataset.colorValue : productData && productData.selectedColor;
    }

    function getSelectedSize() {
        const activeSize = productDetail.querySelector(".size-options button.active");
        return activeSize ? activeSize.dataset.sizeValue : productData && productData.selectedSize;
    }

    function shouldMatchColor() {
        return productData && productData.colorOptionIndex !== null && Boolean(productDetail.querySelector(".color-thumb"));
    }

    function normalizeOption(value) {
        return String(value || "").trim().toLowerCase();
    }

    function optionMatches(optionValue, selectedValue) {
        return normalizeOption(optionValue) === normalizeOption(selectedValue);
    }

    function variantHasOption(variant, value) {
        return Array.isArray(variant.options) && variant.options.some(function (option) {
            return optionMatches(option, value);
        });
    }

    function isVariantAvailable(variant) {
        return Boolean(variant && (variant.available || Number(variant.inventory_quantity) > 0));
    }

    function findVariant(color, size) {
        if (!productData || !productData.variants || productData.variants.length === 0) return null;
        const matchColor = shouldMatchColor();
        const exactVariant = productData.variants.find(function (variant) {
            const colorMatches = !matchColor || optionMatches(variant.options[productData.colorOptionIndex], color);
            const sizeMatches = productData.sizeOptionIndex === null || optionMatches(variant.options[productData.sizeOptionIndex], size);
            return colorMatches && sizeMatches;
        });

        if (exactVariant) return exactVariant;

        return productData.variants.find(function (variant) {
            const colorMatches = !matchColor || variantHasOption(variant, color);
            const sizeMatches = productData.sizeOptionIndex === null || variantHasOption(variant, size);
            return colorMatches && sizeMatches;
        }) || null;
    }

    function updateGallery(color) {
        if (!gallery || !galleryTemplates || !color) return;
        const template = galleryTemplates.querySelector('[data-gallery-template="' + CSS.escape(color) + '"]');
        if (!template || !template.innerHTML.trim()) return;

        gallery.innerHTML = template.innerHTML;
        gallery.querySelectorAll("[data-fancybox]").forEach(function (item) {
            item.setAttribute("data-fancybox", "product-gallery-active");
        });

        if (window.Fancybox) {
            Fancybox.bind('[data-fancybox="product-gallery-active"]', {
                Thumbs: false,
                Toolbar: true
            });
        }
    }

    function updateInventoryState(variant) {
        productDetail.querySelectorAll(".size-options button").forEach(function (button) {
            button.classList.remove("is-error");
        });

        if (!variant) {
            if (sizeMessage) sizeMessage.textContent = "Sorry! Out of stock";
            if (productActions) productActions.classList.add("is-unavailable");
            const activeSize = productDetail.querySelector(".size-options button.active");
            if (activeSize) activeSize.classList.add("is-error");
            return;
        }

        if (priceEl) priceEl.innerHTML = formatMoney(variant.price);
        if (variantInput) variantInput.value = variant.id;
        if (variantSelect) variantSelect.value = String(variant.id);
        if (backInStockTarget) backInStockTarget.dataset.variantId = variant.id;
        wishlistButtons.forEach(function (button) {
            button.dataset.varid = variant.id;
            button.setAttribute("data-varID", variant.id);
        });

        if (isVariantAvailable(variant)) {
            if (productActions) productActions.classList.remove("is-unavailable");

            if (sizeMessage) {
                if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
                    // sizeMessage.textContent = "Only " + variant.inventory_quantity + " Left!";
                    if(variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 2){
                        sizeMessage.textContent = "Last One!";
                    } else {
                        sizeMessage.textContent = "Only a Few Left!";
                    }
                }  else {
                    sizeMessage.textContent = "";
                }
            }
        } else {
            if (sizeMessage) sizeMessage.textContent = "Sorry! Out of stock";
            if (productActions) productActions.classList.add("is-unavailable");
            const activeSize = productDetail.querySelector(".size-options button.active");
            if (activeSize) activeSize.classList.add("is-error");
        }

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", newUrl.toString());
    }

    function updateSelection() {
        updateSizeAvailability();
        const variant = findVariant(getSelectedColor(), getSelectedSize());
        updateInventoryState(variant);
    }

    function updateSizeAvailability() {
        const color = getSelectedColor();

        productDetail.querySelectorAll(".size-options button").forEach(function (button) {
            const size = button.dataset.sizeValue;
            const variant = findVariant(color, size);
            const isUnavailable = !isVariantAvailable(variant);

            button.classList.toggle("is-unavailable", isUnavailable);
            button.setAttribute("aria-disabled", isUnavailable ? "true" : "false");
        });
    }

    productDetail.querySelectorAll(".color-thumb").forEach(function (button) {
        button.addEventListener("click", function () {
            productDetail.querySelectorAll(".color-thumb").forEach(function (item) {
                item.classList.remove("active");
            });
            button.classList.add("active");
            updateGallery(button.dataset.colorValue);
            updateSelection();
        });
    });

    productDetail.querySelectorAll(".size-options button").forEach(function (button) {
        button.addEventListener("click", function () {
            productDetail.querySelectorAll(".size-options button").forEach(function (item) {
                item.classList.remove("active", "is-error");
            });
            button.classList.add("active");
            updateSelection();
        });
    });

    function addVariantToCart(redirectToCheckout) {
        const variantId = variantInput ? variantInput.value : null;
        if (!variantId) return;

        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                id: Number(variantId),
                quantity: 1
            })
        })
            .then(function (response) {
                if (!response.ok) throw new Error("Cart add failed");
                return response.json();
            })
            .then(function () {
                if (redirectToCheckout) {
                    window.location.href = "/checkout";
                    return;
                }
                if (window.FourCartDrawer && typeof window.FourCartDrawer.refreshAndOpen === "function") {
                    window.FourCartDrawer.refreshAndOpen();
                    return;
                }
                window.location.href = "/cart";
            });
    }

    if (addToCartButton) {
        addToCartButton.addEventListener("click", function () {
            addVariantToCart(false);
        });
    }

    if (buyNowButton) {
        buyNowButton.addEventListener("click", function () {
            addVariantToCart(true);
        });
    }

    if (window.Fancybox) {
        Fancybox.bind('[data-fancybox="product-gallery-active"]', {
            Thumbs: false,
            Toolbar: true
        });
    }

    updateSelection();
});

// cart drawer start ===============================
document.addEventListener("DOMContentLoaded", function () {
    const drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;

    const body = drawer.querySelector("[data-cart-drawer-body]");
    const footer = drawer.querySelector("[data-cart-drawer-footer]");
    const subtotal = drawer.querySelector("[data-cart-subtotal]");
    const countEls = document.querySelectorAll("[data-cart-count]");
    const moneyFormat = drawer.dataset.moneyFormat || "{{amount}}";

    function formatMoney(cents) {
        const value = Number(cents || 0) / 100;
        const amount = value.toFixed(2);
        const amountWithCommaSeparator = amount.replace(".", ",");
        const amountNoDecimals = String(Math.round(value));
        const amountNoDecimalsWithCommaSeparator = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        return moneyFormat
            .replace(/\{\{\s*amount\s*\}\}/g, amount)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithCommaSeparator)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithCommaSeparator);
    }

    function getItemImage(item) {
        if (item.image) return item.image;
        if (item.featured_image && item.featured_image.url) return item.featured_image.url;
        return "";
    }

    function getOptionsText(item) {
        if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
            return item.options_with_values
                .filter(function (option) {
                    return option.value && option.value !== "Default Title";
                })
                .map(function (option) {
                    return option.value;
                })
                .join(" / ");
        }
        return item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
    }

    function setCartCount(count) {
        countEls.forEach(function (countEl) {
            countEl.textContent = count;
            countEl.classList.toggle("is-empty", count === 0);
        });
    }

    function openDrawer() {
        drawer.classList.add("is-open");
        drawer.setAttribute("aria-hidden", "false");
        document.body.classList.add("cart-drawer-open");
    }

    function closeDrawer() {
        drawer.classList.remove("is-open");
        drawer.setAttribute("aria-hidden", "true");
        document.body.classList.remove("cart-drawer-open");
    }

    function renderCart(cart) {
        setCartCount(cart.item_count || 0);
        if (subtotal) subtotal.innerHTML = formatMoney(cart.total_price);

        if (!cart.items || cart.items.length === 0) {
            if (body) body.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
            if (footer) footer.hidden = true;
            return;
        }

        if (footer) footer.hidden = false;
        if (!body) return;

        body.innerHTML = "";
        cart.items.forEach(function (item, index) {
            const itemEl = document.createElement("div");
            const imageUrl = getItemImage(item);
            const optionsText = getOptionsText(item);
            itemEl.className = "cart-drawer__item";
            itemEl.dataset.cartLine = String(index + 1);

            const imageLink = document.createElement("a");
            imageLink.className = "cart-drawer__image";
            imageLink.href = item.url || "/cart";

            if (imageUrl) {
                const image = document.createElement("img");
                image.src = imageUrl;
                image.alt = item.product_title || item.title || "Cart item";
                image.loading = "lazy";
                imageLink.appendChild(image);
            } else {
                const placeholder = document.createElement("span");
                placeholder.className = "cart-drawer__placeholder";
                placeholder.textContent = "No image";
                imageLink.appendChild(placeholder);
            }

            const meta = document.createElement("div");
            meta.className = "cart-drawer__meta";

            const title = document.createElement("a");
            title.className = "cart-drawer__title";
            title.href = item.url || "/cart";
            title.textContent = item.product_title || item.title;
            meta.appendChild(title);

            if (optionsText) {
                const options = document.createElement("p");
                options.className = "cart-drawer__options";
                options.textContent = optionsText;
                meta.appendChild(options);
            }

            const row = document.createElement("div");
            row.className = "cart-drawer__row";

            const qty = document.createElement("div");
            qty.className = "cart-drawer__qty";
            qty.innerHTML = '<button type="button" data-cart-qty-change="-1" aria-label="Decrease quantity">-</button><span>' + item.quantity + '</span><button type="button" data-cart-qty-change="1" aria-label="Increase quantity">+</button>';

            const price = document.createElement("strong");
            price.className = "cart-drawer__price";
            price.innerHTML = formatMoney(item.final_line_price);

            row.appendChild(qty);
            row.appendChild(price);
            meta.appendChild(row);

            const remove = document.createElement("button");
            remove.type = "button";
            remove.className = "cart-drawer__remove";
            remove.dataset.cartRemove = "true";
            remove.textContent = "Remove";
            meta.appendChild(remove);

            itemEl.appendChild(imageLink);
            itemEl.appendChild(meta);
            body.appendChild(itemEl);
        });
    }

    function fetchCart() {
        return fetch("/cart.js", {
            headers: {
                "Accept": "application/json"
            }
        })
            .then(function (response) {
                if (!response.ok) throw new Error("Cart fetch failed");
                return response.json();
            })
            .then(function (cart) {
                renderCart(cart);
                return cart;
            });
    }

    function changeLine(line, quantity) {
        return fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                line: Number(line),
                quantity: Math.max(0, quantity)
            })
        })
            .then(function (response) {
                if (!response.ok) throw new Error("Cart update failed");
                return response.json();
            })
            .then(renderCart);
    }

    window.FourCartDrawer = {
        open: openDrawer,
        close: closeDrawer,
        refresh: fetchCart,
        refreshAndOpen: function () {
            return fetchCart().then(function () {
                openDrawer();
            });
        }
    };

    document.querySelectorAll("[data-cart-open]").forEach(function (trigger) {
        trigger.addEventListener("click", function (event) {
            event.preventDefault();
            window.FourCartDrawer.refreshAndOpen();
        });
    });

    function findWishlistVariantId(trigger) {
        const card = trigger.closest('[class*="wishlist" i], [class*="product" i], [class*="item" i], li, tr, article, .card');
        const scope = card || document;
        const selectors = [
            "[data-varid]",
            "[data-varID]",
            "[data-variant-id]",
            "[data-variant]",
            'input[name="id"]',
            'select[name="id"]',
            "select"
        ];

        for (const selector of selectors) {
            const element = scope.querySelector(selector);
            if (!element) continue;

            const value = element.value || element.dataset.varid || element.getAttribute("data-varID") || element.dataset.variantId || element.dataset.variant;
            if (value && /^\d+$/.test(String(value))) return String(value);

            if (element.tagName === "SELECT" && element.selectedOptions && element.selectedOptions.length) {
                const option = element.selectedOptions[0];
                const optionValue = option.value || option.dataset.variantId || option.dataset.varid || option.getAttribute("data-varID");
                if (optionValue && /^\d+$/.test(String(optionValue))) return String(optionValue);
            }
        }

        const variantLink = scope.querySelector('a[href*="variant="]');
        if (variantLink) {
            try {
                const url = new URL(variantLink.getAttribute("href"), window.location.origin);
                const variantId = url.searchParams.get("variant");
                if (variantId && /^\d+$/.test(variantId)) return variantId;
            } catch (error) {
                return "";
            }
        }

        return "";
    }

    function addWishlistItemToCart(variantId, trigger) {
        if (!variantId) return Promise.reject(new Error("Missing variant id"));

        const originalText = trigger.textContent;
        trigger.disabled = true;
        trigger.textContent = "Adding...";

        return fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                id: Number(variantId),
                quantity: 1
            })
        })
            .then(function (response) {
                if (!response.ok) throw new Error("Wishlist add to cart failed");
                return response.json();
            })
            .then(function () {
                return window.FourCartDrawer.refreshAndOpen();
            })
            .finally(function () {
                trigger.disabled = false;
                trigger.textContent = originalText;
            });
    }

    if (window.sessionStorage && window.sessionStorage.getItem("wishlist_move_to_cart_pending") === "true") {
        window.sessionStorage.removeItem("wishlist_move_to_cart_pending");
        [400, 1200, 2400].forEach(function (delay) {
            window.setTimeout(function () {
                window.FourCartDrawer.refreshAndOpen();
            }, delay);
        });
    }

    document.addEventListener("click", function (event) {
        const trigger = event.target.closest("button, a");
        if (!trigger) return;

        const triggerText = (trigger.textContent || "").trim().toLowerCase();
        const isMoveToCart = triggerText.includes("move to cart") || triggerText.includes("add to cart");
        const wishlistContext = trigger.closest('[class*="wishlist" i], [id*="wishlist" i]');
        const isWishlistPage = window.location.pathname.indexOf("wishlist") !== -1;

        if (!isMoveToCart || (!wishlistContext && !isWishlistPage)) return;

        const variantId = findWishlistVariantId(trigger);
        if (!variantId) {
            if (window.sessionStorage) window.sessionStorage.setItem("wishlist_move_to_cart_pending", "true");
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        addWishlistItemToCart(variantId, trigger).catch(function () {
            if (window.sessionStorage) window.sessionStorage.setItem("wishlist_move_to_cart_pending", "true");
            [500, 1300, 2600].forEach(function (delay) {
                window.setTimeout(function () {
                    window.FourCartDrawer.refreshAndOpen();
                }, delay);
            });
        });
    }, true);

    drawer.querySelectorAll("[data-cart-close]").forEach(function (button) {
        button.addEventListener("click", closeDrawer);
    });

    drawer.addEventListener("click", function (event) {
        const item = event.target.closest(".cart-drawer__item");
        if (!item) return;

        const qtyButton = event.target.closest("[data-cart-qty-change]");
        const removeButton = event.target.closest("[data-cart-remove]");

        if (qtyButton) {
            const currentQty = Number(item.querySelector(".cart-drawer__qty span").textContent || 0);
            const nextQty = currentQty + Number(qtyButton.dataset.cartQtyChange);
            changeLine(item.dataset.cartLine, nextQty);
            return;
        }

        if (removeButton) {
            changeLine(item.dataset.cartLine, 0);
        }
    });

    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && drawer.classList.contains("is-open")) {
            closeDrawer();
        }
    });
});

// cart page start ===============================
document.addEventListener("DOMContentLoaded", function () {
    const cartPage = document.querySelector("[data-cart-page]");
    if (!cartPage) return;

    const layout = cartPage.querySelector("[data-cart-page-layout]");
    const itemsEl = cartPage.querySelector("[data-cart-page-items]");
    const emptyEl = cartPage.querySelector("[data-cart-page-empty]");
    const subtotalEl = cartPage.querySelector("[data-cart-page-subtotal]");
    const pageCountEl = cartPage.querySelector("[data-cart-page-count]");
    const headerCountEls = document.querySelectorAll("[data-cart-count]");
    const moneyFormat = cartPage.dataset.moneyFormat || "{{amount}}";
    const removeLabel = cartPage.dataset.removeLabel || "Remove";
    const emptyText = cartPage.dataset.emptyText || "Your shopping bag is empty.";

    function formatCartPageMoney(cents) {
        const value = Number(cents || 0) / 100;
        const amount = value.toFixed(2);
        const amountWithCommaSeparator = amount.replace(".", ",");
        const amountNoDecimals = String(Math.round(value));
        const amountNoDecimalsWithCommaSeparator = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        return moneyFormat
            .replace(/\{\{\s*amount\s*\}\}/g, amount)
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithCommaSeparator)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithCommaSeparator);
    }

    function getCartPageImage(item) {
        if (item.image) return item.image;
        if (item.featured_image && item.featured_image.url) return item.featured_image.url;
        return "";
    }

    function getCartPageOptions(item) {
        if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
            return item.options_with_values
                .filter(function (option) {
                    return option.value && option.value !== "Default Title";
                })
                .map(function (option) {
                    return option.value;
                })
                .join(" / ");
        }

        return item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
    }

    function setCartPageCount(count) {
        const label = count + (count === 1 ? " item" : " items");
        if (pageCountEl) pageCountEl.textContent = label;
        headerCountEls.forEach(function (countEl) {
            countEl.textContent = count;
            countEl.classList.toggle("is-empty", count === 0);
        });
    }

    function createCartPageItem(item, index) {
        const itemEl = document.createElement("article");
        const imageUrl = getCartPageImage(item);
        const optionsText = getCartPageOptions(item);

        itemEl.className = "cart-page__item";
        itemEl.dataset.cartPageItem = "";
        itemEl.dataset.cartLine = String(index + 1);

        const itemLeft = document.createElement("div");
        itemLeft.className = "cart-page__item-left";

        const imageLink = document.createElement("a");
        imageLink.className = "cart-page__image";
        imageLink.href = item.url || "/cart";

        if (imageUrl) {
            const image = document.createElement("img");
            image.src = imageUrl;
            image.alt = item.product_title || item.title || "Cart item";
            image.loading = "lazy";
            imageLink.appendChild(image);
        } else {
            const placeholder = document.createElement("span");
            placeholder.textContent = "No image";
            imageLink.appendChild(placeholder);
        }

        const details = document.createElement("div");
        details.className = "cart-page__details";

        const title = document.createElement("a");
        title.className = "cart-page__title";
        title.href = item.url || "/cart";
        title.textContent = item.product_title || item.title || "Cart item";
        details.appendChild(title);

        if (optionsText) {
            const options = document.createElement("p");
            options.className = "cart-page__options";
            options.textContent = optionsText;
            details.appendChild(options);
        }

        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
            const sellingPlan = document.createElement("p");
            sellingPlan.className = "cart-page__options";
            sellingPlan.textContent = item.selling_plan_allocation.selling_plan.name;
            details.appendChild(sellingPlan);
        }

        const remove = document.createElement("button");
        remove.type = "button";
        remove.className = "cart-page__remove";
        remove.dataset.cartPageRemove = "true";
        remove.textContent = removeLabel;
        details.appendChild(remove);

        const quantity = document.createElement("div");
        quantity.className = "cart-page__quantity";

        const decrease = document.createElement("button");
        decrease.type = "button";
        decrease.dataset.cartPageQtyChange = "-1";
        decrease.setAttribute("aria-label", "Decrease quantity");
        decrease.textContent = "-";

        const qtyInput = document.createElement("input");
        qtyInput.type = "number";
        qtyInput.name = "updates[]";
        qtyInput.value = item.quantity;
        qtyInput.min = "0";
        qtyInput.inputMode = "numeric";
        qtyInput.dataset.cartPageQty = "";
        qtyInput.setAttribute("aria-label", "Quantity for " + (item.product_title || item.title || "cart item"));

        const increase = document.createElement("button");
        increase.type = "button";
        increase.dataset.cartPageQtyChange = "1";
        increase.setAttribute("aria-label", "Increase quantity");
        increase.textContent = "+";

        quantity.appendChild(decrease);
        quantity.appendChild(qtyInput);
        quantity.appendChild(increase);

        const price = document.createElement("div");
        price.className = "cart-page__price";

        if (item.original_line_price !== item.final_line_price) {
            const originalPrice = document.createElement("s");
            originalPrice.innerHTML = formatCartPageMoney(item.original_line_price);
            price.appendChild(originalPrice);
        }

        const finalPrice = document.createElement("strong");
        finalPrice.dataset.cartPageLinePrice = "";
        finalPrice.innerHTML = formatCartPageMoney(item.final_line_price);
        price.appendChild(finalPrice);

        itemLeft.appendChild(imageLink);
        itemLeft.appendChild(details);

        itemEl.appendChild(itemLeft);
        itemEl.appendChild(quantity);
        itemEl.appendChild(price);

        return itemEl;
    }

    function renderCartPage(cart) {
        const itemCount = cart.item_count || 0;
        setCartPageCount(itemCount);
        if (subtotalEl) subtotalEl.innerHTML = formatCartPageMoney(cart.total_price);

        if (layout) layout.classList.toggle("is-hidden", itemCount === 0);
        if (emptyEl) {
            emptyEl.classList.toggle("is-hidden", itemCount > 0);
            const emptyCopy = emptyEl.querySelector("p");
            if (emptyCopy) emptyCopy.textContent = emptyText;
        }

        if (!itemsEl) return;
        itemsEl.innerHTML = "";

        if (!Array.isArray(cart.items) || !cart.items.length) return;

        cart.items.forEach(function (item, index) {
            itemsEl.appendChild(createCartPageItem(item, index));
        });
    }

    function changeCartPageLine(line, quantity) {
        return fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                line: Number(line),
                quantity: Math.max(0, quantity)
            })
        })
            .then(function (response) {
                if (!response.ok) throw new Error("Cart page update failed");
                return response.json();
            })
            .then(function (cart) {
                renderCartPage(cart);
                if (window.FourCartDrawer && typeof window.FourCartDrawer.refresh === "function") {
                    window.FourCartDrawer.refresh();
                }
            });
    }

    cartPage.addEventListener("click", function (event) {
        const qtyButton = event.target.closest("[data-cart-page-qty-change]");
        const removeButton = event.target.closest("[data-cart-page-remove]");
        if (!qtyButton && !removeButton) return;

        const itemEl = event.target.closest("[data-cart-page-item]");
        if (!itemEl) return;

        event.preventDefault();

        if (removeButton) {
            changeCartPageLine(itemEl.dataset.cartLine, 0);
            return;
        }

        const input = itemEl.querySelector("[data-cart-page-qty]");
        const currentQty = input ? Number(input.value || 0) : 0;
        const nextQty = currentQty + Number(qtyButton.dataset.cartPageQtyChange || 0);
        changeCartPageLine(itemEl.dataset.cartLine, nextQty);
    });

    cartPage.addEventListener("change", function (event) {
        const input = event.target.closest("[data-cart-page-qty]");
        if (!input) return;

        const itemEl = input.closest("[data-cart-page-item]");
        if (!itemEl) return;

        const parsedQty = Number(input.value || 0);
        const nextQty = Number.isFinite(parsedQty) ? parsedQty : 0;
        changeCartPageLine(itemEl.dataset.cartLine, nextQty);
    });
});

// read more text start ===============================
$(document).ready(function () {
    function updateProductReadMore(container) {
        var scope = container ? $(container) : $(document);

        scope.find('.product-desc').each(function () {
            var container = $(this);
            var text = container.find('.review-text');
            var toggle = container.find('.review-read-toggle');

            if (!text.length || !toggle.length) return;

            var wasExpanded = text.hasClass('is-expanded');
            text.removeClass('is-expanded');
            text.css('--full-height', text[0].scrollHeight + 'px');

            var isOverflowing = text[0].scrollHeight > text[0].clientHeight + 1;
            text.toggleClass('is-expanded', wasExpanded && isOverflowing);
            toggle
                .prop('hidden', !isOverflowing)
                .text(text.hasClass('is-expanded') ? 'Read Less' : 'Read More')
                .attr('aria-expanded', text.hasClass('is-expanded') ? 'true' : 'false');
        });
    }

    updateProductReadMore(document);

    var productReadMoreResizeTimer;
    $(window).on('load resize', function () {
        clearTimeout(productReadMoreResizeTimer);
        productReadMoreResizeTimer = setTimeout(function () {
            updateProductReadMore(document);
        }, 150);
    });

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
            updateProductReadMore(document);
        });
    }

    $('[data-product-info-tabs]').on('click', '[data-product-tab-button]', function () {
        var button = $(this);
        var tabs = button.closest('[data-product-info-tabs]');
        var target = button.data('product-tab-target');

        tabs.find('[data-product-tab-button]')
            .removeClass('active')
            .attr('aria-selected', 'false');

        button
            .addClass('active')
            .attr('aria-selected', 'true');

        tabs.find('[data-product-tab-panel]')
            .removeClass('active')
            .prop('hidden', true);

        tabs.find('[data-product-tab-panel="' + target + '"]')
            .addClass('active')
            .prop('hidden', false);

        updateProductReadMore(tabs);
    });

    $('.review-read-toggle').on('click', function (e) {
        e.preventDefault();

        var text = $(this).siblings('.review-text');
        if (!text.length) return;

        text.toggleClass('is-expanded');
        $(this)
            .text(text.hasClass('is-expanded') ? 'Read Less' : 'Read More')
            .attr('aria-expanded', text.hasClass('is-expanded') ? 'true' : 'false');
    });
});

// product listing load more start ===============================
document.addEventListener("DOMContentLoaded", function () {
    const filterSidebar = document.querySelector("[data-filter-sidebar]");
    const productListing = document.querySelector("[data-product-listing]");
    const filterLoader = document.querySelector("[data-filter-loader]");
    const sortDropdown = document.querySelector(".sort-dropdown");
    let currentSortBy = (function () {
        const params = new URLSearchParams(window.location.search);
        return params.get("sort_by") || "manual";
    })();
    const appSwatchSelector = "variant-king-combined-listing a, variant-king-combined-listing button, variant-king-combined-listing li, .swatch-view a, .swatch-view button, .swatch-view li";

    function setCardImage(card, nextSrc) {
        const image = card ? card.querySelector(".img-default") : null;
        if (!card || !image || !nextSrc) return;

        if (!image.dataset.originalSrc) {
            image.dataset.originalSrc = image.getAttribute("src") || "";
            image.dataset.originalSrcset = image.getAttribute("srcset") || "";
            image.dataset.originalSizes = image.getAttribute("sizes") || "";
        }

        card.classList.add("is-swatch-hovering");
        image.setAttribute("src", nextSrc);
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
    }

    function setCardSwatchImage(swatch) {
        const card = swatch ? swatch.closest("[data-product-card]") : null;
        const nextSrc = swatch ? swatch.dataset.swatchImage : "";
        setCardImage(card, nextSrc);
    }

    function resetCardSwatchImage(card) {
        const image = card ? card.querySelector(".img-default") : null;
        if (!card || !image || !card.classList.contains("is-swatch-hovering")) return;

        if (image.dataset.originalSrc) {
            image.setAttribute("src", image.dataset.originalSrc);
        }
        if (image.dataset.originalSrcset) {
            image.setAttribute("srcset", image.dataset.originalSrcset);
        } else {
            image.removeAttribute("srcset");
        }
        if (image.dataset.originalSizes) {
            image.setAttribute("sizes", image.dataset.originalSizes);
        } else {
            image.removeAttribute("sizes");
        }
        card.classList.remove("is-swatch-hovering");
    }

    document.addEventListener("mouseover", function (event) {
        const swatch = event.target.closest(".product-color-swatch[data-swatch-image]");
        if (!swatch) return;
        setCardSwatchImage(swatch);
    });

    document.addEventListener("mouseover", function (event) {
        const appSwatch = event.target.closest(appSwatchSelector);
        const card = appSwatch ? appSwatch.closest("[data-product-card]") : null;
        if (!card) return;
        card.classList.add("is-swatch-hovering");
    });

    document.addEventListener("mouseout", function (event) {
        const swatch = event.target.closest(".product-color-swatch[data-swatch-image]");
        if (!swatch) return;
        const card = swatch.closest("[data-product-card]");
        if (card && event.relatedTarget && card.contains(event.relatedTarget) && event.relatedTarget.closest(".product-color-swatch[data-swatch-image]")) return;
        resetCardSwatchImage(card);
    });

    document.addEventListener("mouseout", function (event) {
        const appSwatch = event.target.closest(appSwatchSelector);
        const card = appSwatch ? appSwatch.closest("[data-product-card]") : null;
        if (!card) return;
        if (event.relatedTarget && card.contains(event.relatedTarget) && event.relatedTarget.closest(appSwatchSelector)) return;
        if (!card.querySelector(".product-color-swatch[data-swatch-image]:hover")) {
            card.classList.remove("is-swatch-hovering");
        }
    });

    document.addEventListener("focusin", function (event) {
        const swatch = event.target.closest(".product-color-swatch[data-swatch-image]");
        if (!swatch) return;
        setCardSwatchImage(swatch);
    });

    document.addEventListener("focusout", function (event) {
        const swatch = event.target.closest(".product-color-swatch[data-swatch-image]");
        if (!swatch) return;
        resetCardSwatchImage(swatch.closest("[data-product-card]"));
    });

    function setFilterLoading(isLoading) {
        if (!filterLoader) return;
        filterLoader.classList.toggle("is-active", isLoading);
        filterLoader.setAttribute("aria-hidden", isLoading ? "false" : "true");
    }

    function getCheckedFilterValues(type) {
        if (!filterSidebar) return [];
        return Array.from(filterSidebar.querySelectorAll('[data-filter-input][data-filter-type="' + type + '"]:checked'))
            .map(function (input) {
                return input.value;
            })
            .filter(Boolean);
    }

    function cardMatchesValues(card, dataName, values) {
        if (!values.length) return true;
        const source = card.dataset[dataName] || "";
        return values.some(function (value) {
            return source.indexOf("|" + value + "|") !== -1;
        });
    }

    function filterCards(cards) {
        const selectedCategories = getCheckedFilterValues("category");
        const selectedColors = getCheckedFilterValues("color");
        const selectedSizes = getCheckedFilterValues("size");

        return cards.filter(function (card) {
            return (
                cardMatchesValues(card, "productCategories", selectedCategories) &&
                cardMatchesValues(card, "productColors", selectedColors) &&
                cardMatchesValues(card, "productSizes", selectedSizes)
            );
        });
    }

    function sortCards(cards) {
        const nextCards = cards.slice();

        if (currentSortBy === "price-ascending") {
            nextCards.sort(function (a, b) {
                return Number(a.dataset.productPrice || 0) - Number(b.dataset.productPrice || 0);
            });
            return nextCards;
        }

        if (currentSortBy === "price-descending") {
            nextCards.sort(function (a, b) {
                return Number(b.dataset.productPrice || 0) - Number(a.dataset.productPrice || 0);
            });
            return nextCards;
        }

        return nextCards;
    }

    function getBaseCollectionUrl() {
        return window.location.pathname;
    }

    function buildListingUrl(url) {
        const requestUrl = new URL(url, window.location.origin);

        if (currentSortBy && currentSortBy !== "manual") {
            requestUrl.searchParams.set("sort_by", currentSortBy);
        } else {
            requestUrl.searchParams.delete("sort_by");
        }

        return requestUrl.pathname + requestUrl.search + requestUrl.hash;
    }

    function refreshWishlistButtons(scope) {
        const root = scope || document;

        root.querySelectorAll("[data-wishList]").forEach(function (button) {
            button.style.setProperty("display", "inline-flex", "important");
        });

        document.dispatchEvent(new CustomEvent("hulkapps:wishlist:refresh", {
            detail: {
                container: root
            }
        }));
        document.dispatchEvent(new CustomEvent("hulkappsWishlist:refresh", {
            detail: {
                container: root
            }
        }));

        [
            window.hulkappsWishlist,
            window.HulkappsWishlist,
            window.HulkAppsWishlist,
            window.hulkWishlist,
            window.HulkWishlist
        ].forEach(function (wishlistApp) {
            if (!wishlistApp) return;

            ["init", "initialize", "refresh", "reInit", "reload"].forEach(function (methodName) {
                if (typeof wishlistApp[methodName] === "function") {
                    wishlistApp[methodName](root);
                }
            });
        });
    }

    function refreshProductCardApps(scope) {
        const root = scope || document;

        refreshWishlistButtons(root);

        [
            "variant-king:refresh",
            "variantKing:refresh",
            "sa-variants:refresh",
            "SAVariants:refresh",
            "swatch:refresh",
            "swatches:refresh"
        ].forEach(function (eventName) {
            document.dispatchEvent(new CustomEvent(eventName, {
                detail: {
                    container: root
                }
            }));
        });

        [
            window.VariantKing,
            window.variantKing,
            window.SAVariants,
            window.saVariants,
            window.StarApps,
            window.starApps
        ].forEach(function (app) {
            if (!app) return;

            ["init", "initialize", "refresh", "reInit", "reload", "render"].forEach(function (methodName) {
                if (typeof app[methodName] === "function") {
                    app[methodName](root);
                }
            });
        });
    }

    function syncSortState() {
        if (!sortDropdown) return;

        const activeSortValue = currentSortBy || "manual";
        const activeSortOption = sortDropdown.querySelector('[data-sort-option][data-sort-value="' + activeSortValue + '"]');
        const selectedText = sortDropdown.querySelector(".selected-text");

        sortDropdown.querySelectorAll("[data-sort-option]").forEach(function (option) {
            option.classList.toggle("active", option.dataset.sortValue === activeSortValue);
        });

        if (activeSortOption && selectedText) {
            selectedText.textContent = activeSortOption.textContent.trim();
        }
    }

    function updateSortInUrl() {
        const url = new URL(window.location.href);
        if (currentSortBy && currentSortBy !== "manual") {
            url.searchParams.set("sort_by", currentSortBy);
        } else {
            url.searchParams.delete("sort_by");
        }
        window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    }

    function fetchProductListingPages(url, cards) {
        return fetch(buildListingUrl(url), {
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        })
            .then(function (response) {
                if (!response.ok) throw new Error("Unable to load products");
                return response.text();
            })
            .then(function (html) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");
                const pageCards = Array.from(doc.querySelectorAll("[data-product-grid] [data-product-card]"));
                const nextButton = doc.querySelector(".js-product-load-more");

                pageCards.forEach(function (card) {
                    cards.push(card);
                });

                if (nextButton) {
                    const nextUrl = nextButton.dataset.nextUrl || nextButton.getAttribute("href");
                    if (nextUrl) {
                        return fetchProductListingPages(nextUrl, cards);
                    }
                }

                return cards;
            });
    }

    const webkulSwatchState = {
        isFetching: false,
        hasFetchedAllPages: false,
        cards: []
    };

    function normalizeKey(value) {
        return String(value || "")
            .toLowerCase()
            .replace(/&/g, " and ")
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
    }

    function webkulGroupKey(card) {
        if (!card || !card.dataset.webkulStyleKey) return "";
        return [
            normalizeKey(card.dataset.productVendor),
            normalizeKey(card.dataset.productType),
            normalizeKey(card.dataset.webkulStyleKey)
        ].join("|");
    }

    function webkulTitleBaseKey(card) {
        if (!card || !card.dataset.productTitle || !card.dataset.webkulColourName) return "";

        const suffix = " - " + card.dataset.webkulColourName;
        let title = card.dataset.productTitle;
        if (title.slice(-suffix.length).toLowerCase() === suffix.toLowerCase()) {
            title = title.slice(0, -suffix.length);
        }

        return [
            normalizeKey(card.dataset.productVendor),
            normalizeKey(card.dataset.productType),
            normalizeKey(title)
        ].join("|");
    }

    function webkulCardData(card) {
        if (!card || !card.dataset.webkulStyleKey || !card.dataset.webkulColourName || !card.dataset.webkulColourHex) return null;

        const handle = card.dataset.productHandle || "";
        return {
            handle: handle,
            url: card.dataset.productUrl || (handle ? "/products/" + handle : ""),
            image: card.dataset.productImage || "",
            name: card.dataset.webkulColourName || "",
            colourKey: normalizeKey(card.dataset.webkulColourKey || card.dataset.webkulColourName),
            hex: card.dataset.webkulColourHex || "",
            order: Number(card.dataset.webkulColourOrder || 999)
        };
    }

    function addWebkulKnownCards(cards) {
        const seen = new Set(webkulSwatchState.cards.map(function (card) {
            return card.dataset.productHandle || card.dataset.productId || "";
        }));

        cards.forEach(function (card) {
            const key = card.dataset.productHandle || card.dataset.productId || "";
            if (!key || seen.has(key) || !card.dataset.webkulStyleKey) return;
            seen.add(key);
            webkulSwatchState.cards.push(card);
        });
    }

    function webkulGroups(keyFunction) {
        const groups = {};

        webkulSwatchState.cards.forEach(function (card) {
            const groupKey = keyFunction(card);
            const data = webkulCardData(card);
            if (!groupKey || !data) return;

            if (!groups[groupKey]) groups[groupKey] = [];
            if (groups[groupKey].some(function (item) { return item.handle === data.handle || item.colourKey === data.colourKey; })) return;

            groups[groupKey].push(data);
        });

        Object.keys(groups).forEach(function (groupKey) {
            groups[groupKey].sort(function (a, b) {
                if (a.order !== b.order) return a.order - b.order;
                return a.name.localeCompare(b.name);
            });
        });

        return groups;
    }

    function renderWebkulSwatches(scope) {
        const root = scope && scope.querySelectorAll ? scope : document;
        addWebkulKnownCards(Array.from(root.querySelectorAll("[data-product-card][data-webkul-style-key]")));

        const styleGroups = webkulGroups(webkulGroupKey);
        const titleGroups = webkulGroups(webkulTitleBaseKey);
        root.querySelectorAll("[data-product-card][data-webkul-style-key]").forEach(function (card) {
            const styleGroup = styleGroups[webkulGroupKey(card)] || [];
            const titleGroup = titleGroups[webkulTitleBaseKey(card)] || [];
            const group = styleGroup.length ? styleGroup : titleGroup;
            if (group.length < 2) return;

            const brand = card.querySelector(".product-brand");
            const title = card.querySelector(".product-title");
            if (!brand && !title) return;

            let swatchWrap = card.querySelector(".webkul-colour-swatches");
            if (!swatchWrap) {
                swatchWrap = document.createElement("div");
                swatchWrap.className = "product-colors webkul-colour-swatches";
                swatchWrap.setAttribute("data-webkul-colour-swatches", "");
                (brand || title).insertAdjacentElement(brand ? "afterend" : "beforebegin", swatchWrap);
            }

            swatchWrap.innerHTML = "";
            group.forEach(function (item) {
                const swatch = document.createElement("a");
                swatch.href = item.url;
                swatch.className = "product-color-swatch webkul-colour-swatch";
                if (item.handle && item.handle === card.dataset.productHandle) {
                    swatch.className += " active";
                    swatch.setAttribute("aria-current", "true");
                    swatch.dataset.activeSwatch = "true";
                }
                if (/^#fff(?:fff)?$/i.test(item.hex)) {
                    swatch.className += " is-outline";
                }
                swatch.style.backgroundColor = item.hex;
                if (item.image) swatch.dataset.swatchImage = item.image;
                swatch.setAttribute("aria-label", item.name);
                swatch.title = item.name;

                const label = document.createElement("span");
                label.className = "visually-hidden";
                label.textContent = item.name;
                swatch.appendChild(label);
                swatchWrap.appendChild(swatch);
            });
        });
    }

    function syncWebkulColourSwatches(scope) {
        renderWebkulSwatches(scope);

        const listing = productListing || document.querySelector("[data-product-listing]");
        if (!listing || webkulSwatchState.hasFetchedAllPages || webkulSwatchState.isFetching) return;
        if (!listing.querySelector("[data-product-card][data-webkul-style-key]")) return;

        const fetchMissingWebkulSwatches = function () {
            if (webkulSwatchState.hasFetchedAllPages || webkulSwatchState.isFetching) return;

            webkulSwatchState.isFetching = true;
            fetchProductListingPages(getBaseCollectionUrl(), [])
                .then(function (cards) {
                    addWebkulKnownCards(cards);
                    webkulSwatchState.hasFetchedAllPages = true;
                    renderWebkulSwatches(document);
                })
                .catch(function () {
                    webkulSwatchState.hasFetchedAllPages = true;
                })
                .finally(function () {
                    webkulSwatchState.isFetching = false;
                });
        };

        if ("requestIdleCallback" in window) {
            window.requestIdleCallback(fetchMissingWebkulSwatches, { timeout: 3000 });
        } else {
            window.setTimeout(fetchMissingWebkulSwatches, 1200);
        }
    }

    function closeFilterSidebar() {
        if (!filterSidebar || typeof bootstrap === "undefined" || !bootstrap.Offcanvas) return;
        const instance = bootstrap.Offcanvas.getInstance(filterSidebar);
        if (instance) instance.hide();
    }

    function renderFilteredProducts(cards, showLoadMore) {
        const listing = productListing || document.querySelector("[data-product-listing]");
        const productGrid = listing ? listing.querySelector("[data-product-grid]") : document.querySelector("[data-product-grid]");
        if (!listing || !productGrid) return;

        productGrid.innerHTML = "";

        if (cards.length) {
            cards.forEach(function (card) {
                productGrid.appendChild(card);
            });
            refreshProductCardApps(productGrid);
            syncWebkulColourSwatches(productGrid);
        } else {
            const emptyMessage = document.createElement("p");
            emptyMessage.textContent = "No products found.";
            productGrid.appendChild(emptyMessage);
        }

        const loadMoreWrap = listing.querySelector(".load-more-wrap");
        if (loadMoreWrap && !showLoadMore) {
            loadMoreWrap.remove();
        }
    }

    function reloadProductsWithFilters() {
        if (!productListing) return;

        const applyButton = filterSidebar ? filterSidebar.querySelector("[data-filter-apply]") : null;
        const defaultLabel = applyButton ? applyButton.textContent : "";
        setFilterLoading(true);
        if (applyButton) {
            applyButton.disabled = true;
            applyButton.textContent = "LOADING...";
        }

        fetchProductListingPages(getBaseCollectionUrl(), [])
            .then(function (cards) {
                const filteredCards = filterCards(cards);
                renderFilteredProducts(sortCards(filteredCards), false);
                closeFilterSidebar();
                updateSortInUrl();
            })
            .catch(function () {
                renderFilteredProducts([], false);
            })
            .finally(function () {
                setFilterLoading(false);
                if (applyButton) {
                    applyButton.disabled = false;
                    applyButton.textContent = defaultLabel;
                }
            });
    }

    if (filterSidebar && productListing) {
        const applyButton = filterSidebar.querySelector("[data-filter-apply]");
        const clearButton = filterSidebar.querySelector("[data-filter-clear]");

        if (applyButton) {
            applyButton.addEventListener("click", function () {
                reloadProductsWithFilters();
            });
        }

        if (clearButton) {
            clearButton.addEventListener("click", function () {
                filterSidebar.querySelectorAll("[data-filter-input]").forEach(function (input) {
                    input.checked = false;
                });
                reloadProductsWithFilters();
            });
        }
    }

    if (sortDropdown && productListing) {
        syncSortState();

        sortDropdown.querySelectorAll("[data-sort-option]").forEach(function (option) {
            option.addEventListener("click", function () {
                const nextSortBy = option.dataset.sortValue || "manual";
                if ((currentSortBy || "manual") === nextSortBy) {
                    updateSortInUrl();
                    return;
                }

                currentSortBy = nextSortBy;
                syncSortState();
                reloadProductsWithFilters();
            });
        });
    }

    document.addEventListener("click", function (event) {
        const loadMoreButton = event.target.closest(".js-product-load-more");
        if (!loadMoreButton) return;

        event.preventDefault();

        const listing = loadMoreButton.closest("[data-product-listing]");
        const productGrid = listing ? listing.querySelector("[data-product-grid]") : document.querySelector("[data-product-grid]");
        const nextUrl = loadMoreButton.dataset.nextUrl || loadMoreButton.getAttribute("href");

        if (!productGrid || !nextUrl || loadMoreButton.classList.contains("is-loading")) return;

        const defaultLabel = loadMoreButton.textContent;
        const loadingLabel = loadMoreButton.dataset.loadingLabel || defaultLabel;

        loadMoreButton.classList.add("is-loading");
        loadMoreButton.textContent = loadingLabel;

        fetch(buildListingUrl(nextUrl), {
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        })
            .then(function (response) {
                if (!response.ok) throw new Error("Unable to load products");
                return response.text();
            })
            .then(function (html) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");
                const nextCards = doc.querySelectorAll("[data-product-grid] .product-card");
                const nextButton = doc.querySelector(".js-product-load-more");
                const existingProductKeys = new Set(Array.from(productGrid.querySelectorAll("[data-product-card]")).map(function (card) {
                    return card.dataset.productId || card.dataset.productHandle || "";
                }).filter(Boolean));

                nextCards.forEach(function (card) {
                    const productKey = card.dataset.productId || card.dataset.productHandle || "";
                    if (productKey && existingProductKeys.has(productKey)) return;
                    if (productKey) existingProductKeys.add(productKey);
                    productGrid.appendChild(card);
                });
                refreshProductCardApps(productGrid);
                syncWebkulColourSwatches(productGrid);

                if (nextButton) {
                    const newNextUrl = nextButton.dataset.nextUrl || nextButton.getAttribute("href");
                    loadMoreButton.dataset.nextUrl = newNextUrl;
                    loadMoreButton.setAttribute("href", newNextUrl);
                    loadMoreButton.textContent = defaultLabel;
                    loadMoreButton.classList.remove("is-loading");
                } else {
                    const loadMoreWrap = loadMoreButton.closest(".load-more-wrap");
                    if (loadMoreWrap) loadMoreWrap.remove();
                }
            })
            .catch(function () {
                loadMoreButton.textContent = defaultLabel;
                loadMoreButton.classList.remove("is-loading");
            });
    });

    syncWebkulColourSwatches(document);
});


// Webkul product detail colour swatches ===============================
document.addEventListener("DOMContentLoaded", function () {
    const productDetail = document.querySelector("[data-product-detail][data-webkul-style-key]");
    if (!productDetail) return;

    const collectionUrl = productDetail.dataset.productCollectionUrl;
    const knownCards = [];

    function normalizeKey(value) {
        return String(value || "")
            .toLowerCase()
            .replace(/&/g, " and ")
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
    }

    function cardKey(card) {
        return card.dataset.productHandle || card.dataset.productId || "";
    }

    function addKnownCards(cards) {
        const seen = new Set(knownCards.map(cardKey));

        cards.forEach(function (card) {
            const key = cardKey(card);
            if (!key || seen.has(key) || !card.dataset.webkulStyleKey) return;
            seen.add(key);
            knownCards.push(card);
        });
    }

    function createDetailCardFromDataset() {
        const card = document.createElement("div");
        [
            "productHandle",
            "productTitle",
            "productVendor",
            "productType",
            "productUrl",
            "productImage",
            "webkulStyleCode",
            "webkulStyleKey",
            "webkulColourName",
            "webkulColourKey",
            "webkulColourHex",
            "webkulColourOrder"
        ].forEach(function (key) {
            if (productDetail.dataset[key]) {
                card.dataset[key] = productDetail.dataset[key];
            }
        });
        return card;
    }

    function styleGroupKey(card) {
        if (!card || !card.dataset.webkulStyleKey) return "";
        return [
            normalizeKey(card.dataset.productVendor),
            normalizeKey(card.dataset.productType),
            normalizeKey(card.dataset.webkulStyleKey)
        ].join("|");
    }

    function titleBaseKey(card) {
        if (!card || !card.dataset.productTitle || !card.dataset.webkulColourName) return "";

        const suffix = " - " + card.dataset.webkulColourName;
        let title = card.dataset.productTitle;
        if (title.slice(-suffix.length).toLowerCase() === suffix.toLowerCase()) {
            title = title.slice(0, -suffix.length);
        }

        return [
            normalizeKey(card.dataset.productVendor),
            normalizeKey(card.dataset.productType),
            normalizeKey(title)
        ].join("|");
    }

    function cardData(card) {
        if (!card || !card.dataset.webkulStyleKey || !card.dataset.webkulColourName || !card.dataset.webkulColourHex) return null;

        const handle = card.dataset.productHandle || "";
        return {
            handle: handle,
            url: card.dataset.productUrl || (handle ? "/products/" + handle : ""),
            image: card.dataset.productImage || "",
            name: card.dataset.webkulColourName || "",
            colourKey: normalizeKey(card.dataset.webkulColourKey || card.dataset.webkulColourName),
            hex: card.dataset.webkulColourHex || "",
            order: Number(card.dataset.webkulColourOrder || 999)
        };
    }

    function groupCards(keyFunction) {
        const groups = {};

        knownCards.forEach(function (card) {
            const groupKey = keyFunction(card);
            const data = cardData(card);
            if (!groupKey || !data) return;

            if (!groups[groupKey]) groups[groupKey] = [];
            if (groups[groupKey].some(function (item) { return item.handle === data.handle || item.colourKey === data.colourKey; })) return;

            groups[groupKey].push(data);
        });

        Object.keys(groups).forEach(function (groupKey) {
            groups[groupKey].sort(function (a, b) {
                if (a.order !== b.order) return a.order - b.order;
                return a.name.localeCompare(b.name);
            });
        });

        return groups;
    }

    function renderSwatches() {
        const currentCard = createDetailCardFromDataset();
        const styleGroups = groupCards(styleGroupKey);
        const titleGroups = groupCards(titleBaseKey);
        const styleGroup = styleGroups[styleGroupKey(currentCard)] || [];
        const titleGroup = titleGroups[titleBaseKey(currentCard)] || [];
        const group = styleGroup.length ? styleGroup : titleGroup;
        if (group.length < 2) return;

        let swatchBlock = productDetail.querySelector(".product-split-swatches.webkul-colour-swatches");
        if (!swatchBlock) {
            swatchBlock = document.createElement("div");
            swatchBlock.className = "product-split-swatches webkul-colour-swatches";
            swatchBlock.setAttribute("data-webkul-colour-swatches", "");

            const price = productDetail.querySelector("[data-product-price]");
            const heading = productDetail.querySelector(".product-detail-content .heading-style-5");
            const anchor = price || heading;
            if (!anchor) return;
            anchor.insertAdjacentElement("afterend", swatchBlock);
        }

        swatchBlock.innerHTML = "";

        const label = document.createElement("label");
        label.textContent = productDetail.dataset.webkulColourLabel || "Color";
        swatchBlock.appendChild(label);

        const track = document.createElement("div");
        track.className = "product-split-swatches__track";
        swatchBlock.appendChild(track);

        group.forEach(function (item) {
            const swatch = document.createElement("a");
            swatch.href = item.url;
            swatch.className = "product-split-swatch webkul-colour-swatch";
            if (item.handle && item.handle === productDetail.dataset.productHandle) {
                swatch.className += " active";
                swatch.setAttribute("aria-current", "true");
                swatch.dataset.activeSwatch = "true";
            }
            if (/^#fff(?:fff)?$/i.test(item.hex)) {
                swatch.className += " is-outline";
            }
            swatch.style.backgroundColor = item.hex;
            if (item.image) swatch.dataset.swatchImage = item.image;
            swatch.setAttribute("aria-label", item.name);
            swatch.title = item.name;

            const hiddenText = document.createElement("span");
            hiddenText.className = "visually-hidden";
            hiddenText.textContent = item.name;
            swatch.appendChild(hiddenText);
            track.appendChild(swatch);
        });
    }

    function fetchCollectionPages(url, cards) {
        return fetch(url, {
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        })
            .then(function (response) {
                if (!response.ok) throw new Error("Unable to load product swatches");
                return response.text();
            })
            .then(function (html) {
                const doc = new DOMParser().parseFromString(html, "text/html");
                Array.from(doc.querySelectorAll("[data-product-grid] [data-product-card][data-webkul-style-key]")).forEach(function (card) {
                    cards.push(card);
                });

                const nextButton = doc.querySelector(".js-product-load-more");
                const nextUrl = nextButton && (nextButton.dataset.nextUrl || nextButton.getAttribute("href"));
                if (nextUrl) {
                    return fetchCollectionPages(new URL(nextUrl, window.location.origin).pathname + new URL(nextUrl, window.location.origin).search, cards);
                }

                return cards;
            });
    }

    addKnownCards([createDetailCardFromDataset()]);
    renderSwatches();

    if (collectionUrl) {
        fetchCollectionPages(collectionUrl, [])
            .then(function (cards) {
                addKnownCards(cards);
                renderSwatches();
            })
            .catch(function () {});
    }
});


// journal page masonry (horizontal shortest-column) ===============================
document.addEventListener("DOMContentLoaded", function () {
    const masonry = document.getElementById("journalMasonry");
    if (!masonry) return;

    function vwToPx(vw) {
        return (window.innerWidth * vw) / 100;
    }

    function setMasonryLayout() {
        const cards = masonry.querySelectorAll(".journal-card");
        const containerWidth = masonry.offsetWidth;
        let columns = 3;
        let gapXVw = 5.2;
        let gapYVw = 3.82;

        if (window.innerWidth <= 991) {
            columns = 2;
            gapXVw = 4.04;
            gapYVw = 4.54;
        }
        if (window.innerWidth <= 767) {
            columns = 2;
            gapXVw = 3.91;
            gapYVw = 3.91;
        }

        if (window.innerWidth <= 575) {
            columns = 1;
            gapXVw = 0;
            gapYVw = 6.09;
        }

        const gapX = vwToPx(gapXVw);
        const gapY = vwToPx(gapYVw);

        const cardWidth = (containerWidth - gapX * (columns - 1)) / columns;
        const columnHeights = new Array(columns).fill(0);

        cards.forEach(function (card) {
            card.style.width = cardWidth + "px";

            const shortestColumnIndex = columnHeights.indexOf(Math.min.apply(null, columnHeights));

            const x = shortestColumnIndex * (cardWidth + gapX);
            const y = columnHeights[shortestColumnIndex];

            card.style.transform = "translate(" + x + "px, " + y + "px)";

            columnHeights[shortestColumnIndex] += card.offsetHeight + gapY;
        });

        masonry.style.height = Math.max.apply(null, columnHeights) + "px";
    }

    function imagesLoaded(callback, scope) {
        const imageScope = scope || masonry;
        const images = imageScope.querySelectorAll("img");
        let loadedCount = 0;

        if (images.length === 0) {
            callback();
            return;
        }

        images.forEach(function (img) {
            if (img.complete) {
                loadedCount++;
                if (loadedCount === images.length) callback();
            } else {
                img.addEventListener("load", function () {
                    loadedCount++;
                    if (loadedCount === images.length) callback();
                });
            }
        });
    }

    imagesLoaded(setMasonryLayout);

    window.addEventListener("resize", function () {
        setMasonryLayout();
    });

    document.addEventListener("click", function (event) {
        const loadMoreButton = event.target.closest(".js-journal-load-more");
        if (!loadMoreButton) return;

        event.preventDefault();

        const nextUrl = loadMoreButton.dataset.nextUrl || loadMoreButton.getAttribute("href");
        if (!nextUrl || loadMoreButton.classList.contains("is-loading")) return;

        const defaultLabel = loadMoreButton.textContent;
        const loadingLabel = loadMoreButton.dataset.loadingLabel || defaultLabel;

        loadMoreButton.classList.add("is-loading");
        loadMoreButton.textContent = loadingLabel;

        fetch(nextUrl, {
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Unable to load posts");
                }
                return response.text();
            })
            .then(function (html) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");
                let nextCards = doc.querySelectorAll(".journal-ajax-items .journal-card");
                const nextButton = doc.querySelector(".js-journal-load-more");

                if (nextCards.length === 0) {
                    nextCards = doc.querySelectorAll("#journalMasonry .journal-card");
                }

                nextCards.forEach(function (card) {
                    masonry.appendChild(card);
                });

                if (nextButton) {
                    loadMoreButton.dataset.nextUrl = nextButton.dataset.nextUrl || nextButton.getAttribute("href");
                    loadMoreButton.setAttribute("href", nextButton.getAttribute("href"));
                    loadMoreButton.textContent = defaultLabel;
                    loadMoreButton.classList.remove("is-loading");
                } else {
                    const loadMoreWrap = loadMoreButton.closest(".journal-load-more");
                    if (loadMoreWrap) {
                        loadMoreWrap.remove();
                    }
                }

                imagesLoaded(setMasonryLayout);
            })
            .catch(function () {
                loadMoreButton.textContent = defaultLabel;
                loadMoreButton.classList.remove("is-loading");
            });
    });
});

// Custlo order return / exchange request via Sendcloud Return Portal ===============================
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".four-sendcloud-return-feature, [data-four-sendcloud-modal]").forEach(function (element) {
        element.remove();
    });
    document.body.classList.remove("four-sendcloud-modal-open");
    return;

    const config = window.FourSendcloudReturns || {
        brandDomain: "four-equestrian",
        defaultReasonId: "1",
        defaultDeliveryOption: "drop_off_point",
        returnRefundCode: "money",
        exchangeRefundCode: "exchange",
        replaceRefundCode: "exchange",
        reasons: []
    };

    const invoiceSelector = ".custlo-t1-download-invoice-feature";
    const injectedClass = "four-sendcloud-return-feature";
    const requestTypes = [
        { type: "return", label: "Return Request", title: "RETURN REQUEST" },
        { type: "replace", label: "Replacement Request", title: "REPLACEMENT REQUEST" }
    ];
    let activeOrder = null;
    let activeLookup = null;
    let activeAccessToken = "";
    let portalSettingsPromise = null;
    let postalLookupTimer = null;
    let successCloseTimer = null;
    const productSizeCache = {};
    const requestLockStorageKey = "fourSendcloudRequestLocks";

    function apiBase() {
        return "https://panel.sendcloud.sc/api/v2/brand/" + encodeURIComponent(config.brandDomain || "") + "/return-portal";
    }

    function requestLocks() {
        try {
            return JSON.parse(window.localStorage.getItem(requestLockStorageKey) || "{}");
        } catch (error) {
            return {};
        }
    }

    function setRequestLocks(locks) {
        try {
            window.localStorage.setItem(requestLockStorageKey, JSON.stringify(locks || {}));
        } catch (error) {
            // Storage can be unavailable in private browsing; Sendcloud remains the source of truth.
        }
    }

    function orderLockKey(order) {
        return String((order && (order.name || order.id)) || "").replace(/^#/, "");
    }

    function productLockKey(requestType, sourceIndex, productId) {
        return [requestType || "return", productId || "index-" + sourceIndex].join(":");
    }

    function isRequestLocked(order, requestType, sourceIndex, productId) {
        const orderKey = orderLockKey(order);
        if (!orderKey) return false;

        const locks = requestLocks();
        if (!locks[orderKey]) return false;
        return Boolean(
            locks[orderKey][productLockKey(requestType, sourceIndex, productId)] ||
            locks[orderKey][productLockKey(requestType, sourceIndex, "")]
        );
    }

    function lockRequestedProducts(order, requestType, products) {
        const orderKey = orderLockKey(order);
        if (!orderKey || !products.length) return;

        const locks = requestLocks();
        locks[orderKey] = locks[orderKey] || {};
        products.forEach(function (product) {
            locks[orderKey][productLockKey(requestType, product.sourceIndex, product.productId)] = {
                createdAt: new Date().toISOString()
            };
            locks[orderKey][productLockKey(requestType, product.sourceIndex, "")] = {
                createdAt: new Date().toISOString()
            };
        });
        setRequestLocks(locks);
    }

    function loadPortalSettings() {
        if (!config.brandDomain) return Promise.reject(new Error("Sendcloud brand domain is missing."));
        if (portalSettingsPromise) return portalSettingsPromise;

        portalSettingsPromise = fetch(apiBase(), {
            method: "GET",
            headers: { "Accept": "application/json" }
        })
            .then(function (response) {
                if (!response.ok) throw new Error("Unable to load Sendcloud return portal settings for " + config.brandDomain + " (" + response.status + ").");
                return response.json();
            })
            .then(function (data) {
                const portal = data && data.portal ? data.portal : {};

                if (Array.isArray(portal.reasons) && portal.reasons.length) {
                    config.reasons = portal.reasons.map(function (reason) {
                        return {
                            id: String(reason.id),
                            label: reason.description || reason.label || String(reason.id)
                        };
                    });
                    config.defaultReasonId = config.reasons[0].id;
                }

                if (Array.isArray(portal.delivery_options) && portal.delivery_options.length) {
                    config.deliveryOptions = portal.delivery_options;
                    config.defaultDeliveryOption = portal.delivery_options[0];
                }

                if (Array.isArray(portal.refund_options) && portal.refund_options.length) {
                    config.refundOptions = portal.refund_options;
                    const moneyOption = portal.refund_options.find(function (option) {
                        return option.code === "money";
                    });
                    config.returnRefundCode = (moneyOption || portal.refund_options[0]).code;
                }

                return data;
            });

        return portalSettingsPromise;
    }

    function safeJson(value, fallback) {
        if (!value) return fallback;
        try {
            return JSON.parse(value);
        } catch (error) {
            return fallback;
        }
    }

    function requestConfig(type) {
        return requestTypes.find(function (requestType) {
            return requestType.type === type;
        }) || requestTypes[0];
    }

    function escapeHtml(value) {
        return String(value || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }

    function parsePrice(value) {
        const number = parseFloat(String(value || "0").replace(/[^0-9.]/g, ""));
        return Number.isFinite(number) ? number : 0;
    }

    function humanizeApiMessage(value) {
        if (!value) return "";
        if (typeof value === "string") return value;
        if (Array.isArray(value)) {
            return value.map(humanizeApiMessage).filter(Boolean).join(" ");
        }
        if (typeof value === "object") {
            return Object.keys(value).map(function (key) {
                const message = humanizeApiMessage(value[key]);
                return message ? key.replace(/_/g, " ") + ": " + message : "";
            }).filter(Boolean).join(" ");
        }
        return String(value);
    }

    function apiErrorMessage(data, fallback) {
        return humanizeApiMessage(data && (data.message || data.error || data.errors || data.detail || data.details)) || fallback;
    }

    function uniqueValues(values) {
        return values.reduce(function (items, value) {
            const cleanValue = String(value || "").trim();
            if (cleanValue && items.indexOf(cleanValue) === -1) items.push(cleanValue);
            return items;
        }, []);
    }

    function normalizeProductKey(value) {
        return String(value || "")
            .toLowerCase()
            .replace(/^gid:\/\/shopify\/[^/]+\//, "")
            .replace(/[^a-z0-9]+/g, "");
    }

    function productIdentityValues(product, fallbackIndex) {
        if (!product) return [];

        return uniqueValues([
            product.product_id,
            product.id,
            product.external_id,
            product.variant_id,
            product.sku,
            product.article_number,
            product.title,
            product.product_title,
            product.name,
            fallbackIndex
        ].map(normalizeProductKey));
    }

    function productTitleValue(product) {
        return normalizeProductKey(product && (product.title || product.product_title || product.name));
    }

    function variantParts(value) {
        return String(value || "")
            .split("/")
            .map(function (part) {
                return part.trim();
            })
            .filter(Boolean);
    }

    function currentSizeFromItem(item) {
        const parts = variantParts(item && (item.variant_title || item.variant || item.name));
        return parts.length ? parts[parts.length - 1] : "";
    }

    function productHandleFromItem(item) {
        if (!item) return "";
        const directHandle = item.handle || item.product_handle;
        const url = item.url || item.product_url || item.productUrl || item.href || "";
        const match = String(url).match(/\/products\/([^/?#]+)/);
        return directHandle || (match ? match[1] : "");
    }

    function productSearchQueryFromItem(item) {
        const rawTitle = String((item && (item.title || item.name)) || "").trim();
        const withoutSize = rawTitle.split("/")[0].trim();
        const parts = withoutSize.split(" - ").map(function (part) {
            return part.trim();
        }).filter(Boolean);

        if (parts.length > 2) parts.pop();
        return (parts.join(" - ") || withoutSize || rawTitle).trim();
    }

    function fetchProductHandleBySearch(item) {
        const query = productSearchQueryFromItem(item);
        if (!query) return Promise.resolve("");

        return fetch("/search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product&resources[limit]=1", {
            method: "GET",
            headers: { "Accept": "application/json" }
        })
            .then(function (response) {
                if (!response.ok) return "";
                return response.json();
            })
            .then(function (data) {
                const products = data && data.resources && data.resources.results && Array.isArray(data.resources.results.products)
                    ? data.resources.results.products
                    : [];
                const product = products[0] || {};
                return product.handle || (String(product.url || "").match(/\/products\/([^/?#]+)/) || [])[1] || "";
            })
            .catch(function () {
                return "";
            });
    }

    function selectedLocalIndexes(modal) {
        return Array.prototype.slice.call(modal.querySelectorAll('input[name="four_return_item"]:checked')).map(function (input) {
            return parseInt(input.value || "0", 10);
        }).filter(function (index) {
            return Number.isFinite(index);
        });
    }

    function selectedLocalIndex(modal) {
        const indexes = selectedLocalIndexes(modal);
        return indexes.length ? indexes[0] : -1;
    }

    function activeLocalItem(modal) {
        const index = selectedLocalIndex(modal);
        const items = activeOrder && Array.isArray(activeOrder.lineItems) ? activeOrder.lineItems : [];
        if (index < 0) return {};
        return items[index] || {};
    }

    function activeLocalItems(modal) {
        const items = activeOrder && Array.isArray(activeOrder.lineItems) ? activeOrder.lineItems : [];
        return selectedLocalIndexes(modal).map(function (index) {
            return items[index];
        }).filter(Boolean);
    }

    function sendcloudProductId(product, fallback) {
        if (!product) return fallback || "";
        return product.product_id || product.id || product.external_id || product.sku || product.article_number || fallback || "";
    }

    function fetchProductSizes(item) {
        const currentSize = currentSizeFromItem(item);
        const fallbackSizes = [];

        function requestProduct(handle) {
            if (!handle) return Promise.resolve(fallbackSizes);
            if (productSizeCache[handle]) return productSizeCache[handle];

            productSizeCache[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js", {
                method: "GET",
                headers: { "Accept": "application/json" }
            })
                .then(function (response) {
                    if (!response.ok) throw new Error("Unable to load product sizes.");
                    return response.json();
                })
                .then(function (product) {
                    const options = Array.isArray(product.options) ? product.options : [];
                    const sizeOptionIndex = options.findIndex(function (option) {
                        const name = typeof option === "string" ? option : option && option.name;
                        return /size/i.test(String(name || ""));
                    });
                    const variants = Array.isArray(product.variants) ? product.variants : [];
                    const sizes = variants.map(function (variant) {
                        const variantOptions = Array.isArray(variant.options) ? variant.options : [];
                        const index = sizeOptionIndex > -1 ? sizeOptionIndex + 1 : variantOptions.length;
                        return variant["option" + index] || variantOptions[index - 1];
                    });

                    return uniqueValues([currentSize].concat(sizes));
                })
                .catch(function () {
                    return fallbackSizes;
                });

            return productSizeCache[handle];
        }

        const directHandle = productHandleFromItem(item);
        if (directHandle) return requestProduct(directHandle);

        return fetchProductHandleBySearch(item).then(requestProduct);
    }

    function setMessage(node, message, type) {
        if (!node) return;
        const cleanMessage = humanizeApiMessage(message);
        node.hidden = !cleanMessage;
        node.textContent = cleanMessage || "";
        node.classList.toggle("is-success", type === "success");
    }

    function renderImagePreview(modal) {
        const preview = modal.querySelector("[data-four-sendcloud-image-preview]");
        const input = modal.querySelector("[data-four-sendcloud-images]");
        if (!preview || !input) return;

        preview.innerHTML = "";
        const files = input.files ? Array.prototype.slice.call(input.files, 0, 3) : [];

        files.forEach(function (file) {
            const item = document.createElement("span");
            item.className = "four-sendcloud-upload__preview-item";

            const image = document.createElement("img");
            image.alt = file.name || "Uploaded image";
            image.src = URL.createObjectURL(file);
            image.onload = function () {
                URL.revokeObjectURL(image.src);
            };

            item.appendChild(image);
            preview.appendChild(item);
        });
    }

    function setBusy(button, busy, label) {
        if (!button) return;
        if (busy) {
            button.dataset.defaultText = button.textContent;
            button.textContent = label || "Please wait";
            button.disabled = true;
        } else {
            button.textContent = button.dataset.defaultText || button.textContent;
            button.disabled = false;
        }
    }

    function reasonOptions(selected) {
        const reasons = Array.isArray(config.reasons) ? config.reasons : [];
        return '<option value="">Please Select</option>' + reasons.map(function (reason) {
            const id = String(reason.id);
            return '<option value="' + escapeHtml(id) + '"' + (String(selected || "") === id ? " selected" : "") + ">" + escapeHtml(reason.label || id) + "</option>";
        }).join("");
    }

    function deliveryLabel(option) {
        const labels = {
            drop_off_point: "Drop off point",
            in_store: "Return in store",
            pickup: "Arrange pickup"
        };

        return labels[option] || String(option || "").replace(/_/g, " ");
    }

    function syncPortalOptions(modal) {
        const delivery = modal.querySelector("[data-four-sendcloud-delivery]");
        const reasonSelects = modal.querySelectorAll("[data-four-sendcloud-product-reason]");

        if (delivery && Array.isArray(config.deliveryOptions) && config.deliveryOptions.length) {
            delivery.innerHTML = config.deliveryOptions.map(function (option) {
                return '<option value="' + escapeHtml(option) + '"' + (option === config.defaultDeliveryOption ? " selected" : "") + ">" + escapeHtml(deliveryLabel(option)) + "</option>";
            }).join("");
        }

        reasonSelects.forEach(function (select) {
            select.innerHTML = reasonOptions(select.value);
        });
    }

    function setReplacementOptions(modal, sizes, currentSizes) {
        const wrap = modal.querySelector("[data-four-sendcloud-replacement-options]");
        const options = modal.querySelector("[data-four-sendcloud-size-options]");
        const input = modal.querySelector("[data-four-sendcloud-new-size]");
        const resolution = modal.querySelector("[data-four-sendcloud-resolution]");

        if (!wrap || !options || !input || !resolution) return;

        if (resolution.value !== "replace") {
            wrap.hidden = true;
            input.value = "";
            options.innerHTML = "";
            return;
        }

        const cleanSizes = uniqueValues(sizes || []);
        wrap.hidden = false;
        input.value = "";

        if (!cleanSizes.length) {
            options.innerHTML = '<span class="four-sendcloud-size-empty">Product sizes could not be loaded. Please try again after product details load.</span>';
            return;
        }

        const disabledSizes = uniqueValues(Array.isArray(currentSizes) ? currentSizes : [currentSizes]).map(function (size) {
            return String(size).toLowerCase();
        });

        options.innerHTML = cleanSizes.map(function (size) {
            const isCurrent = disabledSizes.indexOf(String(size).toLowerCase()) > -1;
            return [
                '<button class="four-sendcloud-size-option" type="button" data-four-sendcloud-size-option value="' + escapeHtml(size) + '"' + (isCurrent ? ' disabled' : '') + '>',
                    escapeHtml(size),
                '</button>'
            ].join("");
        }).join("");
    }

    function updateReplacementOptions(modal) {
        const selectedIndexes = selectedLocalIndexes(modal);
        const wrap = modal.querySelector("[data-four-sendcloud-replacement-options]");
        const options = modal.querySelector("[data-four-sendcloud-size-options]");
        const input = modal.querySelector("[data-four-sendcloud-new-size]");
        const resolution = modal.querySelector("[data-four-sendcloud-resolution]");

        if (!selectedIndexes.length) {
            if (wrap && options && input && resolution) {
                input.value = "";
                if (resolution.value === "replace") {
                    wrap.hidden = false;
                    options.innerHTML = '<span class="four-sendcloud-size-empty">Select a product first to choose a replacement size.</span>';
                } else {
                    wrap.hidden = true;
                    options.innerHTML = "";
                }
            }
            return;
        }

        const items = activeLocalItems(modal);
        const currentSizes = uniqueValues(items.map(currentSizeFromItem));

        if (wrap && options && input && resolution && resolution.value === "replace") {
            wrap.hidden = false;
            input.value = "";
            options.innerHTML = '<span class="four-sendcloud-size-empty">Loading sizes...</span>';
        }

        Promise.all(items.map(fetchProductSizes)).then(function (sizeGroups) {
            const sizes = uniqueValues(sizeGroups.reduce(function (allSizes, group) {
                return allSizes.concat(group || []);
            }, currentSizes));
            setReplacementOptions(modal, sizes, currentSizes);
        });
    }

    function getOrderData(button) {
        const actions = button.closest(".custlo-t1-order-detail-actions") || button.parentElement || document;
        const lineItemsSource = button.dataset.lineItems
            ? button
            : actions.querySelector("[data-line-items]");

        return {
            id: button.dataset.orderId || "",
            name: button.dataset.orderName || "",
            templateId: button.dataset.templateId || "",
            invoiceUrl: button.dataset.invoiceUrl || "",
            lineItems: safeJson(lineItemsSource ? lineItemsSource.dataset.lineItems : "", [])
        };
    }

    function orderProductCards(order) {
        const items = Array.isArray(order.lineItems) && order.lineItems.length ? order.lineItems : [];
        const requestType = document.querySelector("[data-four-sendcloud-modal] [data-four-sendcloud-resolution]") && document.querySelector("[data-four-sendcloud-modal] [data-four-sendcloud-resolution]").value || "return";

        if (!items.length) {
            return '<div class="four-sendcloud-return-product four-sendcloud-return-product--empty"><div><h4>Order products</h4><p class="sendcloud-returns__muted">Product details will load from Sendcloud after you submit the postal code.</p></div></div>';
        }

        const availableItems = items.filter(function (item, index) {
            return !isRequestLocked(order, requestType, index, item.id || item.variant_id || item.sku || "");
        });
        const shouldAutoSelect = availableItems.length === 1;
        const cards = items.map(function (item, index) {
            const image = item.image
                ? '<img src="' + escapeHtml(item.image) + '" alt="">'
                : '<span class="sendcloud-returns__empty-image">No image</span>';
            const variant = item.variant_title || item.variant || "";
            const colorMarkup = variant ? '<span>' + escapeHtml(variant) + '</span>' : "";
            const locked = isRequestLocked(order, requestType, index, item.id || item.variant_id || item.sku || "");
            const disabled = locked ? " disabled" : "";
            const checked = !locked && shouldAutoSelect ? " checked" : "";

            return [
                '<label class="four-sendcloud-return-product">',
                    '<input type="checkbox" name="four_return_item" value="' + index + '"' + checked + disabled + '>',
                    '<span class="four-sendcloud-return-product__choice">Select</span>',
                    '<span class="four-sendcloud-return-product__image">' + image + '</span>',
                    '<span class="four-sendcloud-return-product__content">',
                        '<strong>' + escapeHtml(item.title || item.name || "Product") + '</strong>',
                        '<em>' + escapeHtml(item.price || "") + '</em>',
                        '<small>' + escapeHtml(item.quantity || 1) + ' PACK ' + colorMarkup + (locked ? ' <span>REQUEST CREATED</span>' : '') + '</small>',
                    '</span>',
                '</label>'
            ].join("");
        }).join("");

        return '<div class="four-sendcloud-return-product-list"><span>Select product</span>' + cards + '</div>';
    }

    function ensureModal() {
        let modal = document.querySelector("[data-four-sendcloud-modal]");
        if (modal) return modal;

        modal = document.createElement("div");
        modal.className = "four-sendcloud-modal";
        modal.setAttribute("data-four-sendcloud-modal", "");
        modal.innerHTML = [
            '<button class="four-sendcloud-modal__overlay" type="button" data-four-sendcloud-close aria-label="Close"></button>',
            '<div class="four-sendcloud-modal__panel" role="dialog" aria-modal="true" aria-labelledby="FourSendcloudTitle">',
                '<div class="four-sendcloud-modal__header">',
                    '<button class="four-sendcloud-modal__back" type="button" data-four-sendcloud-close aria-label="Back">&lsaquo;</button>',
                    '<div><h2 id="FourSendcloudTitle">RETURN REQUEST</h2><p data-four-sendcloud-subtitle></p></div>',
                    '<div class="sendcloud-returns__notice four-sendcloud-modal__message" data-four-sendcloud-create-message hidden></div>',
                "</div>",
                '<div class="four-sendcloud-modal__body">',
                    '<div class="sendcloud-returns__notice" data-four-sendcloud-config-message hidden></div>',
                    '<form data-four-sendcloud-return-form>',
                        '<div class="four-sendcloud-return-card">',
                            '<div class="four-sendcloud-return-meta">',
                                '<span>Order ID</span>',
                                '<strong data-four-sendcloud-order-id></strong>',
                            '</div>',
                            '<div class="four-sendcloud-return-date" data-four-sendcloud-order-date></div>',
                            '<div class="four-sendcloud-return-layout">',
                                '<div data-four-sendcloud-local-products></div>',
                                '<div>',
                                    '<div class="sendcloud-returns__field four-sendcloud-postal-field">',
                                        '<label for="FourSendcloudPostal">Delivery postal code</label>',
                                        '<input id="FourSendcloudPostal" type="text" name="postal_code" autocomplete="postal-code" required>',
                                    "</div>",
                                    '<input id="FourSendcloudIdentifier" type="hidden" name="identifier">',
                                    '<input id="FourSendcloudResolution" type="hidden" data-four-sendcloud-resolution value="return">',
                                    '<input type="hidden" data-four-sendcloud-delivery value="drop_off_point">',
                                    '<div class="sendcloud-returns__field">',
                                        '<label class="visually-hidden" for="FourSendcloudReason">Reason</label>',
                                        '<select id="FourSendcloudReason" data-four-sendcloud-product-reason required>',
                                            '<option value="">Please Select</option>',
                                        "</select>",
                                    "</div>",
                                    '<div class="four-sendcloud-replacement-options" data-four-sendcloud-replacement-options hidden>',
                                        '<span>Select New Size</span>',
                                        '<div class="four-sendcloud-size-options" data-four-sendcloud-size-options></div>',
                                        '<input type="hidden" data-four-sendcloud-new-size>',
                                    "</div>",
                                    '<label class="four-sendcloud-upload">',
                                        '<input id="FourSendcloudImages" type="file" accept="image/png,image/jpeg" multiple data-four-sendcloud-images>',
                                        '<span class="four-sendcloud-upload__icon">↥</span>',
                                        '<strong>Upload Photos</strong>',
                                        '<small>PNG, JPG up to 1MB - Max 3 Images</small>',
                                        '<span class="four-sendcloud-upload__preview" data-four-sendcloud-image-preview></span>',
                                    '</label>',
                                    '<div class="sendcloud-returns__field">',
                                        '<label class="visually-hidden" for="FourSendcloudNotes">Describe the issue</label>',
                                        '<textarea id="FourSendcloudNotes" data-four-sendcloud-notes placeholder="Describe the issue"></textarea>',
                                    "</div>",
                                "</div>",
                            "</div>",
                        "</div>",
                        '<div class="four-sendcloud-modal__footer">',
                            '<button class="sendcloud-returns__button four-sendcloud-submit" type="submit" data-four-sendcloud-create-button>Submit</button>',
                        "</div>",
                        '<div class="sendcloud-returns__notice" data-four-sendcloud-lookup-message hidden></div>',
                        '<div data-four-sendcloud-result hidden>',
                            '<div data-four-sendcloud-products hidden></div>',
                        "</div>",
                    "</form>",
                    '<template data-four-sendcloud-old-fields>',
                        '<div class="sendcloud-returns__grid" style="margin-top: 22px;">',
                            '<div class="sendcloud-returns__field">',
                                '<label for="FourSendcloudResolution">Request type</label>',
                                '<select id="FourSendcloudResolution" data-four-sendcloud-resolution>',
                                    '<option value="return">Return for refund</option>',
                                    '<option value="exchange">Exchange product</option>',
                                    '<option value="replace">Replace damaged product</option>',
                                "</select>",
                            "</div>",
                            '<div class="sendcloud-returns__field">',
                                '<label for="FourSendcloudDelivery">Return method</label>',
                                '<select id="FourSendcloudDelivery" data-four-sendcloud-delivery>',
                                    '<option value="drop_off_point">Drop off point</option>',
                                    '<option value="in_store">Return in store</option>',
                                    '<option value="pickup">Arrange pickup</option>',
                                "</select>",
                            "</div>",
                        "</div>",
                        '<div class="sendcloud-returns__field" style="margin-top: 16px;">',
                            '<label for="FourSendcloudNotes">Notes</label>',
                            '<textarea id="FourSendcloudNotes" data-four-sendcloud-notes placeholder="Tell us what you need."></textarea>',
                        "</div>",
                        '<div class="sendcloud-returns__field" style="margin-top: 16px;">',
                            '<label for="FourSendcloudImages">Product images</label>',
                            '<input id="FourSendcloudImages" type="file" accept="image/*" multiple data-four-sendcloud-images>',
                            '<p class="sendcloud-returns__muted">Upload up to 5 product images.</p>',
                        "</div>",
                        '<div class="sendcloud-returns__products" data-four-sendcloud-products></div>',
                        '<div class="four-sendcloud-modal__footer">',
                            '<button class="sendcloud-returns__button" type="button" data-four-sendcloud-create-button>Submit request</button>',
                            '<button class="sendcloud-returns__button sendcloud-returns__button--secondary" type="button" data-four-sendcloud-close>Cancel</button>',
                        "</div>",
                        '<div class="sendcloud-returns__notice" data-four-sendcloud-create-message hidden></div>',
                    "</template>",
                "</div>",
            "</div>"
        ].join("");

        document.body.appendChild(modal);
        bindModalEvents(modal);
        return modal;
    }

    function openModal(order, requestType) {
        const modal = ensureModal();
        const nextRequest = requestConfig(requestType || "return");
        const title = modal.querySelector("#FourSendcloudTitle");
        const subtitle = modal.querySelector("[data-four-sendcloud-subtitle]");
        const form = modal.querySelector("[data-four-sendcloud-return-form]");
        const identifier = modal.querySelector("#FourSendcloudIdentifier");
        const resolution = modal.querySelector("[data-four-sendcloud-resolution]");
        const imageInput = modal.querySelector("[data-four-sendcloud-images]");
        const result = modal.querySelector("[data-four-sendcloud-result]");
        const products = modal.querySelector("[data-four-sendcloud-products]");
        const localProducts = modal.querySelector("[data-four-sendcloud-local-products]");
        const orderId = modal.querySelector("[data-four-sendcloud-order-id]");
        const orderDate = modal.querySelector("[data-four-sendcloud-order-date]");
        const configMessage = modal.querySelector("[data-four-sendcloud-config-message]");
        const lookupMessage = modal.querySelector("[data-four-sendcloud-lookup-message]");
        const createMessage = modal.querySelector("[data-four-sendcloud-create-message]");

        activeOrder = order;
        activeLookup = null;
        activeAccessToken = "";
        clearTimeout(successCloseTimer);

        if (title) title.textContent = nextRequest.title;
        subtitle.textContent = "";
        if (form) form.reset();
        if (orderId) orderId.textContent = order.name || order.id || "";
        if (orderDate) orderDate.textContent = "";
        identifier.value = order.name || "";
        resolution.value = nextRequest.type;
        if (imageInput) imageInput.value = "";
        renderImagePreview(modal);
        result.hidden = true;
        products.innerHTML = "";
        if (localProducts) localProducts.innerHTML = orderProductCards(order);
        syncPortalOptions(modal);
        updateReplacementOptions(modal);
        setMessage(lookupMessage, "");
        setMessage(createMessage, "");

        if (!config.brandDomain) {
            setMessage(configMessage, "Sendcloud brand domain is missing in custom.js. Add it to FourSendcloudReturns.brandDomain before testing.");
        } else {
            setMessage(configMessage, "Loading Sendcloud return settings...");
            loadPortalSettings()
                .then(function () {
                    syncPortalOptions(modal);
                    if (Array.isArray(config.reasons) && config.reasons.length) {
                        setMessage(configMessage, "");
                    } else {
                        setMessage(configMessage, "No Sendcloud return reasons found. Add reasons in Sendcloud return portal settings.");
                    }
                })
                .catch(function (error) {
                    setMessage(configMessage, error.message || "Unable to load Sendcloud return settings.");
                });
        }

        modal.classList.add("is-open");
        document.body.classList.add("four-sendcloud-modal-open");
    }

    function closeModal() {
        const modal = document.querySelector("[data-four-sendcloud-modal]");
        if (!modal) return;
        clearTimeout(successCloseTimer);
        modal.classList.remove("is-open");
        document.body.classList.remove("four-sendcloud-modal-open");
    }

    function renderProducts(modal, data) {
        const payload = data && data.data ? data.data : {};
        const productsWrap = modal.querySelector("[data-four-sendcloud-products]");
        const products = Array.isArray(payload.products) ? payload.products : [];

        if (!products.length) {
            productsWrap.innerHTML = '<div class="sendcloud-returns__notice">No returnable products were found for this order.</div>';
            return;
        }

        productsWrap.innerHTML = products.map(function (product, index) {
            const locked = isRequestLocked(activeOrder, modal.querySelector("[data-four-sendcloud-resolution]").value || "return", index, sendcloudProductId(product, index));
            const disabled = product.returnable === false || locked ? " disabled" : "";
            const checked = product.returnable === false || locked ? "" : " checked";
            const image = product.image_url
                ? '<img src="' + escapeHtml(product.image_url) + '" alt="">'
                : '<span class="sendcloud-returns__empty-image">No image</span>';

            return [
                '<div class="sendcloud-returns__product" data-four-sendcloud-product data-four-sendcloud-product-index="' + index + '">',
                    '<input type="checkbox" data-four-sendcloud-product-check' + checked + disabled + '>',
                    '<div class="sendcloud-returns__product-image">' + image + "</div>",
                    "<div>",
                        "<h4>" + escapeHtml(product.name || "Product") + "</h4>",
                        '<p class="sendcloud-returns__muted">' + escapeHtml(product.price || "") + (product.returnable === false ? " - Not returnable" : "") + (locked ? " - Request created" : "") + "</p>",
                        '<div class="sendcloud-returns__product-controls">',
                            '<div class="sendcloud-returns__field">',
                                "<label>Qty</label>",
                                '<input type="number" min="1" max="' + escapeHtml(product.quantity || 1) + '" value="' + escapeHtml(product.quantity || 1) + '" data-four-sendcloud-product-qty>',
                            "</div>",
                            '<div class="sendcloud-returns__field">',
                                "<label>Reason</label>",
                                '<select data-four-sendcloud-product-reason>' + reasonOptions(config.defaultReasonId) + "</select>",
                            "</div>",
                        "</div>",
                        '<input type="hidden" data-four-sendcloud-product-id value="' + escapeHtml(sendcloudProductId(product, index)) + '">',
                        '<input type="hidden" data-four-sendcloud-product-name value="' + escapeHtml(product.name || "Product") + '">',
                        '<input type="hidden" data-four-sendcloud-product-price value="' + escapeHtml(product.price || 0) + '">',
                    "</div>",
                "</div>"
            ].join("");
        }).join("");
    }

    function renderLocalProductsFromSendcloud(modal, data) {
        const payload = data && data.data ? data.data : {};
        const productsWrap = modal.querySelector("[data-four-sendcloud-local-products]");
        const products = Array.isArray(payload.products) ? payload.products : [];

        if (!productsWrap || !products.length) return;

        const requestType = modal.querySelector("[data-four-sendcloud-resolution]").value || "return";
        const returnableProducts = products.filter(function (product, index) {
            return product.returnable !== false && !isRequestLocked(activeOrder, requestType, index, sendcloudProductId(product, index));
        });
        const shouldAutoSelect = returnableProducts.length === 1;

        productsWrap.innerHTML = '<div class="four-sendcloud-return-product-list"><span>Select product</span>' + products.map(function (product, index) {
            const image = product.image_url
                ? '<img src="' + escapeHtml(product.image_url) + '" alt="">'
                : '<span class="sendcloud-returns__empty-image">No image</span>';
            const locked = isRequestLocked(activeOrder, requestType, index, sendcloudProductId(product, index));
            const disabled = product.returnable === false || locked ? " disabled" : "";
            const checked = product.returnable === false || locked ? "" : (shouldAutoSelect ? " checked" : "");

            return [
                '<label class="four-sendcloud-return-product">',
                    '<input type="checkbox" name="four_return_item" value="' + index + '"' + checked + disabled + '>',
                    '<span class="four-sendcloud-return-product__choice">Select</span>',
                    '<span class="four-sendcloud-return-product__image">' + image + '</span>',
                    '<span class="four-sendcloud-return-product__content">',
                        '<strong>' + escapeHtml(product.name || "Product") + '</strong>',
                        '<em>' + escapeHtml(product.price || "") + '</em>',
                        '<small>' + escapeHtml(product.quantity || 1) + ' PACK' + (product.returnable === false ? ' <span>NOT RETURNABLE</span>' : '') + (locked ? ' <span>REQUEST CREATED</span>' : '') + '</small>',
                    '</span>',
                '</label>'
            ].join("");
        }).join("") + '</div>';
    }

    function selectedProducts(modal, sourceIndexes) {
        const requestedIndexes = Array.isArray(sourceIndexes) ? sourceIndexes : null;
        const usedNodes = [];

        function productNodePayload(productNode, sourceIndex) {
            const quantity = parseInt(productNode.querySelector("[data-four-sendcloud-product-qty]").value, 10);
            const reason = productNode.querySelector("[data-four-sendcloud-product-reason]").value || config.defaultReasonId;

            return {
                _sourceIndex: sourceIndex,
                product_id: productNode.querySelector("[data-four-sendcloud-product-id]").value,
                quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
                description: productNode.querySelector("[data-four-sendcloud-product-name]").value,
                value: parsePrice(productNode.querySelector("[data-four-sendcloud-product-price]").value),
                return_reason: parseInt(reason, 10)
            };
        }

        function productNodeIdentities(productNode) {
            return productIdentityValues({
                id: productNode.querySelector("[data-four-sendcloud-product-id]").value,
                name: productNode.querySelector("[data-four-sendcloud-product-name]").value
            }, productNode.dataset.fourSendcloudProductIndex);
        }

        function findProductNodeForLocalIndex(productNodes, localIndex) {
            const localItems = activeOrder && Array.isArray(activeOrder.lineItems) ? activeOrder.lineItems : [];
            const localItem = localItems[localIndex] || {};
            const localIdentities = productIdentityValues(localItem, localIndex);
            const localTitle = productTitleValue(localItem);

            const availableNodes = productNodes.filter(function (productNode) {
                const checkbox = productNode.querySelector("[data-four-sendcloud-product-check]");
                return usedNodes.indexOf(productNode) === -1 && (!checkbox || !checkbox.disabled);
            });

            const sameIndexNode = availableNodes.find(function (productNode) {
                return parseInt(productNode.dataset.fourSendcloudProductIndex || "-1", 10) === localIndex;
            });
            if (sameIndexNode) return sameIndexNode;

            const identityNode = availableNodes.find(function (productNode) {
                const nodeIdentities = productNodeIdentities(productNode);
                return localIdentities.some(function (identity) {
                    return identity && nodeIdentities.indexOf(identity) !== -1;
                });
            });
            if (identityNode) return identityNode;

            if (localTitle) {
                const titleNode = availableNodes.find(function (productNode) {
                    const productTitle = productTitleValue({
                        name: productNode.querySelector("[data-four-sendcloud-product-name]").value
                    });
                    return productTitle && (productTitle.indexOf(localTitle) !== -1 || localTitle.indexOf(productTitle) !== -1);
                });
                if (titleNode) return titleNode;
            }

            return availableNodes[0] || null;
        }

        const productNodes = Array.prototype.slice.call(modal.querySelectorAll("[data-four-sendcloud-product]"));

        if (requestedIndexes) {
            return requestedIndexes.reduce(function (items, localIndex) {
                const productNode = findProductNodeForLocalIndex(productNodes, localIndex);
                if (!productNode) return items;

                usedNodes.push(productNode);
                items.push(productNodePayload(productNode, localIndex));
                return items;
            }, []);
        }

        return productNodes.reduce(function (items, productNode) {
            const checkbox = productNode.querySelector("[data-four-sendcloud-product-check]");
            const sourceIndex = parseInt(productNode.dataset.fourSendcloudProductIndex || "-1", 10);

            if (!checkbox || !checkbox.checked || checkbox.disabled) {
                return items;
            }

            items.push(productNodePayload(productNode, sourceIndex));
            return items;
        }, []);
    }

    function selectedProductsSummary(modal, selectedProducts, replacementSize, sourceIndexes) {
        const selectedIndexes = Array.isArray(sourceIndexes) ? sourceIndexes : selectedLocalIndexes(modal);
        const items = activeOrder && Array.isArray(activeOrder.lineItems) ? activeOrder.lineItems : [];
        const summaries = selectedProducts.map(function (product, index) {
            const item = items[selectedIndexes[index]] || {};
            const title = item.title || item.name || product.description || "Product";
            const variant = item.variant_title || item.variant || "";
            const quantity = item.quantity || product.quantity || 1;
            const currentSize = currentSizeFromItem(item);
            const parts = [
                "Product: " + title,
                "Qty: " + quantity
            ];

            if (variant) parts.push("Variant: " + variant);
            if (currentSize) parts.push("Current size: " + currentSize);
            if (replacementSize) parts.push("New size: " + replacementSize);
            if (product.value) parts.push("Value: " + product.value);

            return parts.join(" | ");
        });

        return summaries.join(" || ");
    }

    function refundCode(resolution) {
        if (resolution === "exchange") return config.exchangeRefundCode || "exchange";
        if (resolution === "replace") return config.replaceRefundCode || "exchange";
        return config.returnRefundCode || "money";
    }

    function selectedImages(modal) {
        const input = modal.querySelector("[data-four-sendcloud-images]");
        return input && input.files ? Array.prototype.slice.call(input.files, 0, 3) : [];
    }

    function normalizeUploadedImage(image, productId) {
        if (!image) return "";
        if (typeof image === "object") {
            const filename = image.filename || image.id || image.uuid || image.file || "";
            const name = image.name || filename || "";
            const path = image.path || image.url || image.image || "";

            if (!filename && !path) return "";
            const nextImage = {
                filename: filename,
                name: name,
                path: path
            };

            if (productId) {
                nextImage.product_id = productId;
                nextImage.product = productId;
            }
            return nextImage;
        }
        return "";
    }

    function uploadedImagesPayload(uploadedImages, productId) {
        return uploadedImages.reduce(function (images, image) {
            const value = normalizeUploadedImage(image, productId);
            if (value) images.push(value);
            return images;
        }, []);
    }

    function uploadReturnImages(files) {
        if (!files.length) return Promise.resolve([]);
        if (!activeAccessToken) return Promise.reject(new Error("Find eligible products before uploading images."));

        const formData = new FormData();
        files.forEach(function (file, index) {
            formData.append("image_" + (index + 1), file, file.name);
        });

        return fetch(apiBase() + "/uploads", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Authorization": "Bearer " + activeAccessToken
            },
            body: formData
        })
            .then(function (response) {
                return response.json().catch(function () {
                    return [];
                }).then(function (data) {
                    if (!response.ok) throw new Error(apiErrorMessage(data, "Unable to upload product images."));
                    if (Array.isArray(data)) return data;
                    if (Array.isArray(data.images)) return data.images;
                    if (Array.isArray(data.uploads)) return data.uploads;
                    if (Array.isArray(data.data)) return data.data;
                    return [];
                });
            });
    }

    function lookupSendcloudOrder(modal, identifier, postalCode) {
        const cleanIdentifier = String(identifier || "").trim();
        const cleanPostalCode = String(postalCode || "").trim();
        const identifiers = cleanIdentifier.charAt(0) === "#"
            ? [cleanIdentifier, cleanIdentifier.slice(1)]
            : [cleanIdentifier];

        function request(nextIdentifierIndex) {
            const nextIdentifier = identifiers[nextIdentifierIndex];

            return fetch(apiBase() + "/outgoing?identifier=" + encodeURIComponent(nextIdentifier) + "&postal_code=" + encodeURIComponent(cleanPostalCode), {
                method: "GET",
                headers: { "Accept": "application/json" }
            })
                .then(function (response) {
                    if (!response.ok && identifiers[nextIdentifierIndex + 1]) {
                        return request(nextIdentifierIndex + 1);
                    }

                    if (!response.ok) throw new Error("No matching Sendcloud shipment was found.");
                    return response.json();
                });
        }

        return loadPortalSettings()
            .then(function () {
                syncPortalOptions(modal);
                return request(0);
            })
            .then(function (data) {
                activeLookup = data;
                activeAccessToken = data.access_token || "";
                renderProducts(modal, data);
                renderLocalProductsFromSendcloud(modal, data);
                syncPortalOptions(modal);
                updateReplacementOptions(modal);
                return data;
            });
    }

    function bindModalEvents(modal) {
        modal.addEventListener("click", function (event) {
            if (event.target.closest("[data-four-sendcloud-close]")) {
                closeModal();
            }

            const sizeButton = event.target.closest("[data-four-sendcloud-size-option]");
            if (sizeButton && !sizeButton.disabled) {
                const input = modal.querySelector("[data-four-sendcloud-new-size]");
                modal.querySelectorAll("[data-four-sendcloud-size-option]").forEach(function (button) {
                    button.classList.toggle("is-selected", button === sizeButton);
                });
                if (input) input.value = sizeButton.value || "";
            }
        });

        modal.addEventListener("change", function (event) {
            if (event.target.matches('input[name="four_return_item"]')) {
                updateReplacementOptions(modal);
            }

            if (event.target.matches("[data-four-sendcloud-images]")) {
                renderImagePreview(modal);
            }
        });

        modal.querySelector("#FourSendcloudPostal").addEventListener("change", function (event) {
            const postalCode = String(event.currentTarget.value || "").trim();
            const identifier = String(modal.querySelector("#FourSendcloudIdentifier").value || "").trim();
            const message = modal.querySelector("[data-four-sendcloud-create-message]");

            setMessage(message, "");

            if (!identifier || !postalCode || !config.brandDomain) return;

            lookupSendcloudOrder(modal, identifier, postalCode)
                .catch(function (error) {
                    setMessage(message, error.message || "Unable to load order products.");
                });
        });

        modal.querySelector("#FourSendcloudPostal").addEventListener("input", function (event) {
            clearTimeout(postalLookupTimer);
            postalLookupTimer = setTimeout(function () {
                event.currentTarget.dispatchEvent(new Event("change", { bubbles: true }));
            }, 700);
        });

        modal.querySelector("[data-four-sendcloud-return-form]").addEventListener("submit", function (event) {
            event.preventDefault();

            const createMessage = modal.querySelector("[data-four-sendcloud-create-message]");
            const result = modal.querySelector("[data-four-sendcloud-result]");
            const button = modal.querySelector("[data-four-sendcloud-create-button]");
            const formData = new FormData(event.currentTarget);
            const identifier = String(formData.get("identifier") || "").trim();
            const postalCode = String(formData.get("postal_code") || "").trim();
            const visibleReason = modal.querySelector("#FourSendcloudReason");
            const images = selectedImages(modal);
            const deliveryOption = modal.querySelector("[data-four-sendcloud-delivery]").value || config.defaultDeliveryOption || "drop_off_point";
            const resolution = modal.querySelector("[data-four-sendcloud-resolution]").value || "return";
            const replacementSizeInput = modal.querySelector("[data-four-sendcloud-new-size]");
            const replacementSize = replacementSizeInput ? String(replacementSizeInput.value || "").trim() : "";
            const userNote = modal.querySelector("[data-four-sendcloud-notes]").value || resolution;
            const requestedProductIndexes = selectedLocalIndexes(modal);
            let productsToLockOnSuccess = [];
            let note = userNote;

            setMessage(createMessage, "");
            result.hidden = true;

            if (!config.brandDomain) {
                setMessage(createMessage, "Sendcloud brand domain is missing.");
                return;
            }

            if (!identifier || !postalCode || !visibleReason.value) {
                setMessage(createMessage, "Enter postal code and select a return reason.");
                return;
            }

            if (!requestedProductIndexes.length) {
                setMessage(createMessage, resolution === "replace" ? "Please select the product you want to replace." : "Please select the product you want to return.");
                return;
            }

            if (resolution === "replace" && !replacementSize) {
                setMessage(createMessage, "Please select a new size for replacement.");
                return;
            }

            if (images.length > 3) {
                setMessage(createMessage, "Upload a maximum of 3 product images.");
                return;
            }

            const invalidImage = images.find(function (image) {
                return image.size > 1024 * 1024 || ["image/png", "image/jpeg"].indexOf(image.type) === -1;
            });

            if (invalidImage) {
                setMessage(createMessage, "Upload PNG or JPG images up to 1MB each.");
                return;
            }

            setBusy(button, true, "Submitting");

            lookupSendcloudOrder(modal, identifier, postalCode)
                .then(function () {
                    modal.querySelectorAll("[data-four-sendcloud-product-reason]").forEach(function (select) {
                        select.value = visibleReason.value;
                    });

                    const lookupData = activeLookup && activeLookup.data ? activeLookup.data : null;
                    const parcel = lookupData ? lookupData.parcel || {} : {};
                    const servicePoint = lookupData ? lookupData.service_point || null : null;
                    const products = selectedProducts(modal, requestedProductIndexes);

                    if (!activeAccessToken || !parcel.id) {
                        throw new Error("Unable to prepare this return request.");
                    }

                    if (!products.length) {
                        throw new Error("No returnable products were found for this order.");
                    }

                    const selectedProductsForReturn = requestedProductIndexes.map(function (selectedProductIndex) {
                        return products.find(function (product) {
                            return product._sourceIndex === selectedProductIndex;
                        });
                    }).filter(Boolean);

                    productsToLockOnSuccess = selectedProductsForReturn.map(function (product) {
                        return {
                            sourceIndex: product._sourceIndex,
                            productId: product.product_id
                        };
                    });

                    selectedProductsForReturn.forEach(function (product) {
                        delete product._sourceIndex;
                    });

                    if (!selectedProductsForReturn.length) {
                        throw new Error("No selected products were found for this order.");
                    }

                    const productSummary = selectedProductsSummary(modal, selectedProductsForReturn, resolution === "replace" ? replacementSize : "", requestedProductIndexes);

                    if (resolution === "replace") {
                        note = "Replacement requested. " + productSummary + " | Note: " + note;
                    } else {
                        note = productSummary + " | Note: " + note;
                    }

                    const body = {
                        reason: selectedProductsForReturn[0].return_reason,
                        message: note,
                        outgoing_parcel: parcel.id,
                        refund: {
                            refund_type: { code: refundCode(resolution) },
                            message: note
                        },
                        delivery_option: deliveryOption,
                        products: selectedProductsForReturn,
                        incoming_parcel: {
                            collo_count: parcel.collo_count || 1,
                            from_address_1: parcel.address || "",
                            from_address_2: parcel.address_2 || "",
                            from_city: parcel.city || "",
                            from_company_name: parcel.company_name || "",
                            from_country: parcel.country && parcel.country.iso_2 ? parcel.country.iso_2 : "",
                            from_email: parcel.email || "",
                            from_house_number: parcel.house_number || (parcel.address_divided && parcel.address_divided.house_number) || "",
                            from_country_state: parcel.to_state || "",
                            from_name: parcel.name || "",
                            from_postal_code: parcel.postal_code || "",
                            from_telephone: parcel.telephone || ""
                        }
                    };

                    if (deliveryOption.indexOf("drop_off") === 0 && servicePoint && servicePoint.id) {
                        body.service_point = { id: servicePoint.id };
                        body.selected_functionalities = { first_mile: "dropoff" };
                    }

                    if (parcel.carrier && parcel.carrier.code) {
                        body.selected_carrier_code = parcel.carrier.code;
                    } else if (lookupData.carriers && lookupData.carriers[0] && lookupData.carriers[0].code) {
                        body.selected_carrier_code = lookupData.carriers[0].code;
                    }

                    return uploadReturnImages(images).then(function (uploadedImages) {
                        return { uploadedImages: uploadedImages, body: body };
                    });
                })
                .then(function (prepared) {
                    const body = prepared.body;
                    const uploadedImages = prepared.uploadedImages;
                    if (uploadedImages.length) {
                        const productId = body.products && body.products[0] ? body.products[0].product_id : "";
                        const imagePayload = uploadedImagesPayload(uploadedImages, productId);
                        if (imagePayload.length) {
                            body.images = imagePayload;
                        }
                    }

                    return fetch(apiBase() + "/incoming", {
                        method: "POST",
                        headers: {
                            "Accept": "application/json",
                            "Authorization": "Bearer " + activeAccessToken,
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(body)
                    });
                })
                .then(function (response) {
                    return response.json().catch(function () {
                        return {};
                    }).then(function (data) {
                        if (!response.ok) throw new Error(apiErrorMessage(data, "Unable to create this request."));
                        return data;
                    });
                })
	                .then(function () {
	                    lockRequestedProducts(activeOrder, resolution, productsToLockOnSuccess);
	                    const form = modal.querySelector("[data-four-sendcloud-return-form]");
	                    const successMessage = resolution === "replace"
	                        ? "Your replacement request has been created. Please check your email for replacement instructions."
	                        : "Your return request has been created. Please check your email for return instructions.";
	                    setMessage(createMessage, successMessage, "success");
	                    successCloseTimer = setTimeout(function () {
	                        closeModal();
	                        if (form) form.reset();
                        renderImagePreview(modal);
                    }, 5000);
                })
                .catch(function (error) {
                    setMessage(createMessage, error.message || "Unable to submit this return request.");
                })
                .finally(function () {
                    setBusy(button, false);
                });
        });
    }

    function injectButtons(scope) {
        const root = scope || document;

        root.querySelectorAll('.custlo-t1-order-detail-actions [data-route*="cd_order_edit"], .custlo-t1-order-detail-actions .custlo-t1-order-view-btn').forEach(function (editButton) {
            editButton.hidden = true;
            editButton.style.display = "none";
        });

        root.querySelectorAll(invoiceSelector).forEach(function (invoiceButton) {
            const actions = invoiceButton.parentElement;
            if (!actions || actions.querySelector("." + injectedClass)) return;

            let insertAfter = invoiceButton;
            requestTypes.forEach(function (requestType) {
                const button = document.createElement("button");
                button.type = "button";
                button.className = injectedClass;
                button.textContent = requestType.label;
                button.dataset.fourSendcloudRequestType = requestType.type;
                button.dataset.fourSendcloudOrder = JSON.stringify(getOrderData(invoiceButton));
                insertAfter.insertAdjacentElement("afterend", button);
                insertAfter = button;
            });
        });
    }

    document.addEventListener("click", function (event) {
        const button = event.target.closest("." + injectedClass);
        if (!button) return;

        event.preventDefault();
        openModal(safeJson(button.dataset.fourSendcloudOrder, {}), button.dataset.fourSendcloudRequestType || "return");
    });

	    injectButtons(document);

	    const observer = new MutationObserver(function (mutations) {
	        mutations.forEach(function (mutation) {
	            mutation.addedNodes.forEach(function (node) {
	                if (node.nodeType === 1) {
	                    injectButtons(node);
	                }
	            });
	        });
	    });

    observer.observe(document.body, { childList: true, subtree: true });
});
